// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27160%27 height=%27160%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.85%27 numOctaves=%272%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   TeSalut Giveaway (raffle) campaign page.
   Premium SaaS aesthetic (Linear / Stripe / Raycast) warmed by a honey/gold
   brand: refined neutral surfaces, near-black/near-white text, and gold used
   deliberately for action, light and celebration — never as a flood of yellow.
   Light + dark themes via [data-theme]. Scoped under .rf-page.
   Mobile-first; scales at 640px (tablet) and 1024px (desktop).
   ========================================================================== */

/* Registered custom properties enable animating gradient angles & spotlights. */
@property --rf-angle {
  syntax: '<angle>';
  inherits: false;
  initial-value: 0deg;
}

.rf-page {
  /* ---- Brand constants ---- */
  --rf-honey: #fbbf24;
  --rf-amber: #f59e0b;
  --rf-amber-deep: #d97706;
  --rf-gold-grad: linear-gradient(135deg, #fde68a 0%, #fbbf24 42%, #f59e0b 100%);
  --rf-gold-grad-strong: linear-gradient(135deg, #fcd34d 0%, #f59e0b 55%, #d97706 100%);

  /* ---- Light theme (default) ---- */
  --rf-bg: #fffdfa; /* warm white */
  --rf-bg-soft: #faf7f1; /* cream off-white */
  --rf-surface: #ffffff;
  --rf-surface-soft: #f6f3ed;
  --rf-glass: rgba(255, 255, 255, 0.72);
  --rf-border: rgba(28, 25, 23, 0.09);
  --rf-border-strong: rgba(28, 25, 23, 0.16);

  --rf-text: #1c1917;
  --rf-text-soft: #57534e;
  --rf-text-faint: #a8a29e;

  --rf-accent: var(--rf-honey);
  --rf-accent-text: #b45309; /* honey accent text w/ AA contrast on light */
  --rf-accent-wash: rgba(251, 191, 36, 0.12);
  --rf-accent-soft: rgba(245, 158, 11, 0.38);
  --rf-spot: rgba(251, 191, 36, 0.28);
  /* Gradient-clipped text: kept dark enough at every stop to hold AA/large-text
     contrast on the page background (unlike --rf-gold-grad*, which is tuned to
     sit *behind* dark button text, not to be read as foreground text itself). */
  --rf-text-grad: linear-gradient(135deg, #b45309 0%, #92400e 55%, #7c2d12 100%);

  /* Gold action button */
  --rf-btn-bg: var(--rf-gold-grad-strong);
  --rf-btn-fg: #422006;
  --rf-btn-glow: 0 8px 18px -6px rgba(217, 119, 6, 0.5);

  --rf-shadow-sm: 0 1px 2px rgba(28, 25, 23, 0.04), 0 6px 16px -10px rgba(28, 25, 23, 0.14);
  --rf-shadow-md: 0 6px 14px -6px rgba(28, 25, 23, 0.1), 0 24px 48px -22px rgba(28, 25, 23, 0.22);
  --rf-shadow-gold: 0 18px 50px -20px rgba(245, 158, 11, 0.45);

  --rf-hex-line: rgba(180, 83, 9, 0.07);
  --rf-glow-1: rgba(251, 191, 36, 0.22);
  --rf-glow-2: rgba(245, 158, 11, 0.14);

  /* avatar tints */
  --rf-av-fg: #78350f;
  --rf-av-0: linear-gradient(135deg, rgba(253, 230, 138, 0.7), rgba(251, 191, 36, 0.35));
  --rf-av-1: linear-gradient(135deg, rgba(28, 25, 23, 0.08), rgba(28, 25, 23, 0.03));
  --rf-av-2: linear-gradient(135deg, rgba(168, 162, 158, 0.22), rgba(168, 162, 158, 0.08));
  --rf-av-3: linear-gradient(135deg, rgba(217, 119, 6, 0.28), rgba(245, 158, 11, 0.12));

  --rf-radius: 20px;
  --rf-radius-sm: 14px;
  --rf-radius-pill: 999px;
  /* Fluid content width — grows on larger displays (see responsive section). */
  --rf-container: 1240px;
  --rf-gutter: clamp(20px, 4vw, 56px);
  --rf-font: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;

  position: relative;
  min-height: 100vh;
  font-family: var(--rf-font);
  color: var(--rf-text);
  background: var(--rf-bg);
  color-scheme: light;
  -webkit-font-smoothing: antialiased;
  text-rendering: optimizeLegibility;
  font-feature-settings: 'cv11', 'ss01';
  overflow-x: hidden;
}

.rf-page[data-theme='dark'] {
  --rf-bg: #0b0a09;
  --rf-bg-soft: #100e0c;
  --rf-surface: #17150f;
  --rf-surface-soft: #1f1c16;
  --rf-glass: rgba(34, 30, 22, 0.55);
  --rf-border: rgba(255, 240, 214, 0.09);
  --rf-border-strong: rgba(255, 240, 214, 0.18);

  --rf-text: #fafaf9;
  --rf-text-soft: #b6b0a6;
  --rf-text-faint: #79716a;

  --rf-accent-text: #fcd34d;
  --rf-accent-wash: rgba(251, 191, 36, 0.14);
  --rf-accent-soft: rgba(251, 191, 36, 0.42);
  --rf-spot: rgba(251, 191, 36, 0.22);
  --rf-text-grad: linear-gradient(135deg, #fde68a 0%, #fcd34d 55%, #f5b83d 100%);

  --rf-btn-fg: #2a1a02;

  --rf-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.45), 0 6px 16px -8px rgba(0, 0, 0, 0.6);
  --rf-shadow-md: 0 10px 26px -10px rgba(0, 0, 0, 0.65), 0 28px 56px -24px rgba(0, 0, 0, 0.75);
  --rf-shadow-gold: 0 20px 60px -22px rgba(245, 158, 11, 0.5);

  --rf-hex-line: rgba(251, 191, 36, 0.07);
  --rf-glow-1: rgba(251, 191, 36, 0.2);
  --rf-glow-2: rgba(217, 119, 6, 0.16);

  --rf-av-fg: #fde68a;
  --rf-av-0: linear-gradient(135deg, rgba(251, 191, 36, 0.32), rgba(217, 119, 6, 0.16));
  --rf-av-1: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03));
  --rf-av-2: linear-gradient(135deg, rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.02));
  --rf-av-3: linear-gradient(135deg, rgba(245, 158, 11, 0.3), rgba(217, 119, 6, 0.14));

  color-scheme: dark;
}

.rf-page *,
.rf-page *::before,
.rf-page *::after {
  box-sizing: border-box;
}

/* Neutralise the app-wide global heading rule (styles.css sets a navy colour
   and heading font on every h1-h6) so raffle headings follow the theme.
   Only colour/family are reset — per-class size & weight intentionally win. */
.rf-page h1,
.rf-page h2,
.rf-page h3,
.rf-page h4,
.rf-page h5,
.rf-page h6 {
  color: inherit;
  font-family: inherit;
}

/* Disable transitions during a theme swap so colours change instantly. */
.rf-page--switching,
.rf-page--switching * {
  transition: none !important;
}

.rf-page :focus-visible {
  outline: 2px solid var(--rf-amber);
  outline-offset: 2px;
  border-radius: 8px;
}
/* Pill controls must keep their full radius on focus so the outline hugs the
   pill instead of falling back to the generic 8px (which clips the rounded ends). */
.rf-page .rf-btn:focus-visible {
  border-radius: var(--rf-radius-pill);
}
.rf-page .rf-prize-pick:focus-visible {
  border-radius: 18px;
}

/* Skip link --------------------------------------------------------------- */
.rf-skip {
  position: absolute;
  left: 16px;
  top: -60px;
  z-index: 60;
  padding: 10px 16px;
  border-radius: var(--rf-radius-pill);
  background: var(--rf-text);
  color: var(--rf-bg);
  font-weight: 600;
  text-decoration: none;
  transition: top 0.2s ease;
}
.rf-skip:focus {
  top: 16px;
}

/* ==========================================================================
   Utilities — gradient text + film grain
   ========================================================================== */
/* Gold gradient clipped to text. Use for one emphasised phrase per view (hero
   headline accent, winner name) — not for whole paragraphs. */
.rf-grad-text {
  background-image: var(--rf-text-grad);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
/* Faint animated-free noise texture for the always-dark surfaces (header,
   footer, hero, winner modal), à la Linear/Stripe. Static (no motion), so it
   needs no reduced-motion guard. Host element needs position + overflow:hidden
   for the tile to clip to any border-radius. */
.rf-grain {
  position: relative;
}
.rf-grain::before {
  content: '';
  position: absolute;
  inset: 0;
  z-index: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 160px 160px;
  opacity: 0.05;
  mix-blend-mode: overlay;
  pointer-events: none;
}

/* ==========================================================================
   Buttons
   ========================================================================== */
.rf-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 22px;
  border: 1px solid transparent;
  border-radius: var(--rf-radius-pill);
  font-family: inherit;
  font-size: 0.94rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  line-height: 1;
  cursor: pointer;
  text-decoration: none;
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.22s ease,
    filter 0.22s ease, background 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
}
.rf-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.rf-btn--lg {
  padding: 15px 28px;
  font-size: 1rem;
}

/* Primary = gold action with a warm glow. Kept deliberately simple (single
   box-shadow, no clipped pseudo-element sheen) — overflow:hidden + a rounded
   border-radius + an inner shadow/gradient combo triggered a corner-seam
   rendering artifact in some browsers where a stray sliver of the sheen
   showed up outside the pill near the top-left corner. */
.rf-btn--primary,
.rf-btn--gold {
  color: var(--rf-btn-fg);
  background-image: var(--rf-gold-grad-strong);
  box-shadow: var(--rf-btn-glow);
}
.rf-btn--primary:hover:not(:disabled),
.rf-btn--gold:hover:not(:disabled) {
  transform: translateY(-2px);
  filter: saturate(1.08) brightness(1.03);
  box-shadow: 0 12px 26px -8px rgba(217, 119, 6, 0.6);
}
.rf-btn--ghost {
  color: var(--rf-text);
  background: var(--rf-surface);
  border-color: var(--rf-border-strong);
  box-shadow: var(--rf-shadow-sm);
}
.rf-btn--ghost:hover:not(:disabled) {
  background: var(--rf-surface-soft);
  border-color: var(--rf-accent-soft);
  transform: translateY(-1px);
}

/* ==========================================================================
   Header
   ========================================================================== */
/* Dark brand bar (matches the main TeSalut site header): near-black surface with
   the gold wordmark, independent of the page's light/dark theme. Controls inside
   are re-tinted for the dark bar below. */
.rf-header {
  position: sticky;
  top: 0;
  z-index: 40;
  /* Dark→dark-grey gradient bar with rounded bottom edges, flush to the top. */
  background: linear-gradient(180deg, #1c1a18 0%, #302d2a 62%, #3c3936 100%);
  backdrop-filter: blur(16px) saturate(1.4);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0 0 26px 26px;
  box-shadow: 0 16px 36px -22px rgba(0, 0, 0, 0.9);
  overflow: hidden;
}
.rf-header__inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: var(--rf-container);
  margin: 0 auto;
  padding: 14px clamp(20px, 4vw, 56px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.rf-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}
.rf-brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: #fafaf9;
}
.rf-brand__logo {
  display: block;
  height: clamp(30px, 3.2vw, 40px);
  width: auto;
}
.rf-brand__tag {
  padding: 4px 10px;
  border-radius: var(--rf-radius-pill);
  background: rgba(253, 207, 8, 0.14);
  border: 1px solid rgba(253, 207, 8, 0.4);
  font-size: 0.62rem;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #fcd34d;
  font-weight: 700;
}

/* Re-tint the header controls for the always-dark bar. */
.rf-header .rf-theme-toggle {
  border-color: rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
  color: rgba(250, 250, 249, 0.78);
}
.rf-header .rf-theme-toggle:hover {
  color: #fcd34d;
  border-color: rgba(253, 207, 8, 0.5);
}
.rf-header .rf-lang {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
}
.rf-header .rf-lang__btn {
  color: rgba(250, 250, 249, 0.6);
}
.rf-header .rf-lang__btn[aria-pressed='true'] {
  color: #fcd34d;
}
.rf-header .rf-lang__thumb {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(253, 207, 8, 0.45);
}
/* On narrow phones the wordmark + controls fill the bar; drop the tag pill. */
@media (max-width: 420px) {
  .rf-brand__tag {
    display: none;
  }
}

/* Theme toggle */
.rf-theme-toggle {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  border-radius: var(--rf-radius-pill);
  border: 1px solid var(--rf-border);
  background: var(--rf-surface);
  color: var(--rf-text-soft);
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;
}
.rf-theme-toggle:hover {
  color: var(--rf-accent-text);
  border-color: var(--rf-accent-soft);
  transform: translateY(-1px);
}
.rf-theme-toggle__icon {
  display: grid;
  place-items: center;
}

/* Language switcher */
.rf-lang {
  position: relative;
  display: inline-flex;
  padding: 4px;
  border-radius: var(--rf-radius-pill);
  background: var(--rf-surface-soft);
  border: 1px solid var(--rf-border);
}
.rf-lang__btn {
  position: relative;
  z-index: 1;
  min-width: 44px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  border-radius: var(--rf-radius-pill);
  font-family: inherit;
  font-weight: 600;
  font-size: 0.8rem;
  color: var(--rf-text-faint);
  cursor: pointer;
  transition: color 0.2s ease;
}
.rf-lang__btn[aria-pressed='true'] {
  color: var(--rf-accent-text);
}
.rf-lang__thumb {
  position: absolute;
  top: 4px;
  bottom: 4px;
  width: 44px;
  border-radius: var(--rf-radius-pill);
  background: var(--rf-surface);
  border: 1px solid var(--rf-accent-soft);
  box-shadow: var(--rf-shadow-sm);
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.rf-lang__thumb[data-active='ru'] {
  transform: translateX(0);
}
.rf-lang__thumb[data-active='ro'] {
  transform: translateX(44px);
}

/* ==========================================================================
   Layout primitives
   ========================================================================== */
.rf-main {
  position: relative;
  z-index: 1;
}
.rf-section {
  position: relative;
  width: 100%;
  max-width: var(--rf-container);
  margin: 0 auto;
  padding: 80px var(--rf-gutter);
}
.rf-section__head {
  max-width: 680px;
  margin: 0 auto 48px;
  text-align: center;
}
.rf-section__title {
  margin: 20px 0 14px;
  font-size: clamp(1.8rem, 4vw, 2.7rem);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.1;
}
.rf-section__subtitle {
  margin: 0;
  color: var(--rf-text-soft);
  font-size: 1.05rem;
  line-height: 1.6;
}
.rf-count-pill {
  display: inline-block;
  margin-left: 10px;
  padding: 3px 11px;
  border-radius: var(--rf-radius-pill);
  background: var(--rf-accent-wash);
  border: 1px solid var(--rf-accent-soft);
  color: var(--rf-accent-text);
  font-size: 0.8rem;
  font-weight: 700;
  vertical-align: middle;
}

/* ==========================================================================
   Honeycomb backdrop (layered grid + glow + floating hexes + parallax)
   ========================================================================== */
.rf-honeycomb {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}
.rf-honeycomb__grid {
  position: absolute;
  inset: -60px;
  color: var(--rf-hex-line);
  transition: transform 0.35s ease-out;
}
.rf-honeycomb__grid--back {
  mask-image: radial-gradient(120% 78% at 50% 8%, #000 24%, transparent 70%);
  transform: translate(calc(var(--rf-px, 0) * -16px), calc(var(--rf-py, 0) * -12px));
  opacity: 0.7;
}
.rf-honeycomb__grid--front {
  mask-image: radial-gradient(95% 70% at 50% 14%, #000 16%, transparent 62%);
  transform: translate(calc(var(--rf-px, 0) * 22px), calc(var(--rf-py, 0) * 16px));
  color: var(--rf-accent-wash);
}
.rf-honeycomb__glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(20px);
  pointer-events: none;
}
.rf-honeycomb__glow--primary {
  top: -220px;
  left: 50%;
  width: 760px;
  height: 540px;
  transform: translateX(-50%);
  background: radial-gradient(closest-side, var(--rf-glow-1), transparent 72%);
  animation: rf-glow-breathe 9s ease-in-out infinite;
}
.rf-honeycomb__glow--secondary {
  top: 40px;
  right: -160px;
  width: 460px;
  height: 460px;
  background: radial-gradient(closest-side, var(--rf-glow-2), transparent 72%);
  animation: rf-glow-breathe 11s ease-in-out infinite reverse;
}
@keyframes rf-glow-breathe {
  0%, 100% { opacity: 0.75; transform: translateX(-50%) scale(1); }
  50% { opacity: 1; transform: translateX(-50%) scale(1.06); }
}
.rf-honeycomb__glow--secondary {
  /* secondary isn't centered, so override the translate in the keyframe */
  animation-name: rf-glow-breathe-2;
}
@keyframes rf-glow-breathe-2 {
  0%, 100% { opacity: 0.6; transform: scale(1); }
  50% { opacity: 0.95; transform: scale(1.08); }
}

.rf-honeycomb__particles {
  position: absolute;
  inset: 0;
  transform: translate(calc(var(--rf-px, 0) * 34px), calc(var(--rf-py, 0) * 26px));
  transition: transform 0.35s ease-out;
}
.rf-hex-particle {
  position: absolute;
  width: var(--rf-hp-size);
  height: calc(var(--rf-hp-size) * 1.14);
  color: var(--rf-accent-soft);
  opacity: 0.45;
  animation: rf-float var(--rf-hp-dur, 10s) ease-in-out var(--rf-hp-delay, 0s) infinite;
  will-change: transform;
}
@keyframes rf-float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-22px) rotate(calc(var(--rf-hp-spin, 1) * 12deg)); }
}

/* ==========================================================================
   Section 1 — Hero
   ========================================================================== */
.rf-hero {
  position: relative;
  /* Full-bleed: the background wash + honeycomb span the whole viewport width
     (no side "bars"); the content stays centred inside .rf-hero__inner. */
  max-width: none;
  width: 100%;
  padding: 72px 0 100px;
  overflow: hidden;
}
/* Theme-aware hero backdrop. The video is gone; the depth now comes from a soft
   radial wash behind the honeycomb grid + the people collage on the right. */
.rf-page[data-theme='dark'] .rf-hero {
  background:
    radial-gradient(120% 120% at 82% 8%, rgba(245, 158, 11, 0.16) 0%, transparent 46%),
    radial-gradient(130% 100% at 50% -10%, rgba(24, 21, 16, 0.9) 0%, #0b0a09 60%);
}
.rf-page[data-theme='light'] .rf-hero {
  background:
    radial-gradient(120% 120% at 82% 8%, rgba(245, 158, 11, 0.1) 0%, transparent 48%),
    linear-gradient(180deg, var(--rf-bg-soft) 0%, var(--rf-bg) 72%);
}
.rf-hero__inner {
  position: relative;
  z-index: 1;
  max-width: var(--rf-container);
  margin: 0 auto;
  padding: 0 var(--rf-gutter);
  display: grid;
  gap: 48px;
  align-items: center;
}
.rf-hero__content {
  transform: translate(calc(var(--rf-px, 0) * 6px), calc(var(--rf-py, 0) * 4px));
  transition: transform 0.4s ease-out;
}
.rf-hero__pulse {
  position: relative;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--rf-amber);
  box-shadow: 0 0 0 0 var(--rf-accent-soft);
  animation: rf-ping 2.2s ease-out infinite;
}
@keyframes rf-ping {
  0% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.5); }
  70%, 100% { box-shadow: 0 0 0 8px rgba(245, 158, 11, 0); }
}
.rf-hero__title {
  margin: 24px 0 18px;
  font-size: clamp(1.85rem, 7vw, 3.9rem);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.04em;
  overflow-wrap: break-word;
  hyphens: auto;
}
.rf-hero__subtitle {
  margin: 0 0 32px;
  max-width: 540px;
  font-size: 1.12rem;
  line-height: 1.62;
  color: var(--rf-text-soft);
}
.rf-hero__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
  margin-bottom: 40px;
}
.rf-hero__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 34px;
  margin: 0;
}
.rf-hero__stat {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.rf-hero__stat-value {
  font-size: 1.7rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  min-height: 1.7rem;
  display: flex;
  align-items: center;
  font-variant-numeric: tabular-nums;
}
.rf-hero__stat-label {
  margin: 0;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--rf-text-faint);
  font-weight: 700;
}
.rf-hero__stat--live .rf-hero__stat-value .rf-hero__pulse {
  width: 12px;
  height: 12px;
}

/* Right-side hero visual — the people-honeycomb collage. Drifts subtly with the
   pointer parallax like the old cards did. */
.rf-hero__visual {
  display: flex;
  justify-content: center;
  transform: translate(calc(var(--rf-px, 0) * -14px), calc(var(--rf-py, 0) * -10px));
  transition: transform 0.4s ease-out;
}
.rf-hero__honeycomb {
  width: 100%;
  max-width: 640px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 30px 60px rgba(0, 0, 0, 0.35));
}

/* ==========================================================================
   Section 2 — Prizes
   ========================================================================== */
.rf-prizes__grid {
  display: grid;
  gap: 22px;
}
.rf-prize {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 32px;
  border-radius: var(--rf-radius);
  border: 1px solid var(--rf-border);
  background: var(--rf-glass);
  backdrop-filter: blur(14px) saturate(1.3);
  box-shadow: var(--rf-shadow-sm);
  overflow: hidden;
  transform-style: preserve-3d;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}
.rf-prize:hover {
  box-shadow: var(--rf-shadow-md), var(--rf-shadow-gold);
}
.rf-prize--active {
  border-color: var(--rf-accent-soft);
  box-shadow: var(--rf-shadow-md), var(--rf-shadow-gold);
}
/* Animated gradient border (rotates on hover / when active). */
.rf-prize__border {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1.5px;
  background: conic-gradient(
    from var(--rf-angle),
    transparent 0deg,
    var(--rf-honey) 60deg,
    var(--rf-amber) 110deg,
    transparent 180deg,
    transparent 360deg
  );
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.35s ease;
  pointer-events: none;
}
.rf-prize:hover .rf-prize__border,
.rf-prize--active .rf-prize__border {
  opacity: 1;
  animation: rf-spin-border 4s linear infinite;
}
@keyframes rf-spin-border {
  to { --rf-angle: 360deg; }
}
.rf-prize__spotlight {
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: radial-gradient(240px circle at var(--rf-mx, 50%) var(--rf-my, 50%), var(--rf-spot), transparent 60%);
  opacity: 0;
  transition: opacity 0.35s ease;
  pointer-events: none;
}
.rf-prize:hover .rf-prize__spotlight {
  opacity: 1;
}
.rf-prize__sheen {
  position: absolute;
  inset: 0;
  background: linear-gradient(115deg, transparent 35%, rgba(255, 255, 255, 0.14) 48%, transparent 62%);
  transform: translateX(-130%);
  transition: transform 0.85s ease;
  pointer-events: none;
}
.rf-prize:hover .rf-prize__sheen {
  transform: translateX(130%);
}
.rf-prize__chip {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: var(--rf-radius-pill);
  background: var(--rf-gold-grad);
  color: #422006;
  font-size: 0.7rem;
  font-weight: 700;
  box-shadow: 0 4px 12px -4px rgba(245, 158, 11, 0.6);
}
/* Price + "grand prize" ribbon sit on the photo/art tile itself (not the card),
   so they read as a product tag rather than floating card chrome. */
.rf-prize__price-badge {
  position: absolute;
  left: 12px;
  bottom: 12px;
  z-index: 2;
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  padding: 7px 13px;
  border-radius: var(--rf-radius-pill);
  background: rgba(20, 16, 10, 0.72);
  backdrop-filter: blur(8px) saturate(1.4);
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow: 0 8px 20px -8px rgba(0, 0, 0, 0.5);
}
.rf-prize__price-num {
  font-size: 1.05rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  font-variant-numeric: tabular-nums;
  background-image: var(--rf-gold-grad);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.rf-prize__price-cur {
  font-size: 0.66rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: rgba(255, 255, 255, 0.75);
}
.rf-prize__ribbon {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 2;
  padding: 6px 12px;
  border-radius: var(--rf-radius-pill);
  background-image: var(--rf-gold-grad-strong);
  color: #2a1a02;
  font-size: 0.66rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: 0 6px 16px -6px rgba(245, 158, 11, 0.65);
}
.rf-prize__art {
  position: relative;
  width: 116px;
  height: 116px;
  margin-bottom: 24px;
  display: grid;
  place-items: center;
  border-radius: 24px;
  background: var(--rf-surface-soft);
  border: 1px solid var(--rf-border);
  color: var(--rf-text-soft);
  transform: translateZ(28px);
  transition: color 0.3s ease, background 0.3s ease, border-color 0.3s ease;
}
.rf-prize:hover .rf-prize__art,
.rf-prize--active .rf-prize__art {
  color: var(--rf-accent-text);
  border-color: var(--rf-accent-soft);
  background: var(--rf-accent-wash);
}
.rf-prize__art-glow {
  position: absolute;
  inset: 12px;
  border-radius: 50%;
  background: radial-gradient(closest-side, var(--rf-glow-1), transparent 72%);
  opacity: 0;
  filter: blur(8px);
  transition: opacity 0.35s ease;
}
.rf-prize:hover .rf-prize__art-glow,
.rf-prize--active .rf-prize__art-glow {
  opacity: 1;
}
.rf-prize__art-ring {
  position: absolute;
  inset: -1px;
  border-radius: inherit;
  border: 1.5px solid transparent;
  background: var(--rf-gold-grad) border-box;
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.35s ease;
}
.rf-prize--active .rf-prize__art-ring {
  opacity: 1;
}
.rf-prize__illustration {
  position: relative;
  width: 78px;
  height: 78px;
}
/* Photo mode: a generated (Nano Banana) image shown as a premium banner.
   Falls back to .rf-prize__art when the file is missing (see PrizeCard). */
.rf-prize__photo {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  margin-bottom: 24px;
  border-radius: 20px;
  overflow: hidden;
  background: var(--rf-surface-soft);
  border: 1px solid var(--rf-border);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);
  transform: translateZ(28px);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}
.rf-prize__photo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transform: scale(1.01);
  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);
  animation: rf-photo-in 0.7s ease both;
}
@keyframes rf-photo-in {
  from { opacity: 0; }
  to { opacity: 1; }
}
.rf-prize:hover .rf-prize__photo-img,
.rf-prize--active .rf-prize__photo-img {
  transform: scale(1.06);
}
/* Warm gradient veil so any photo blends into the honey theme + keeps title legible. */
.rf-prize__photo::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 55%, rgba(28, 25, 23, 0.14) 100%);
  pointer-events: none;
}
.rf-page[data-theme='dark'] .rf-prize__photo::after {
  background: linear-gradient(180deg, transparent 45%, rgba(0, 0, 0, 0.4) 100%);
}
/* Gold ring that lights up on hover / active, matching the SVG art tile. */
.rf-prize__photo-ring {
  position: absolute;
  inset: 0;
  z-index: 1;
  border-radius: inherit;
  padding: 1.5px;
  background: var(--rf-gold-grad);
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.35s ease;
  pointer-events: none;
}
.rf-prize:hover .rf-prize__photo-ring,
.rf-prize--active .rf-prize__photo-ring {
  opacity: 1;
}
.rf-prize:hover .rf-prize__photo,
.rf-prize--active .rf-prize__photo {
  border-color: var(--rf-accent-soft);
}
.rf-prize__title {
  margin: 0 0 12px;
  font-size: 1.3rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}
.rf-prize__desc {
  margin: 0 0 20px;
  color: var(--rf-text-soft);
  line-height: 1.62;
  flex: 1 1;
}
.rf-prize__select {
  position: relative;
  z-index: 2;
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 20px;
  border-radius: var(--rf-radius-pill);
  border: 1px solid var(--rf-border-strong);
  background: var(--rf-surface);
  color: var(--rf-text);
  font-family: inherit;
  font-weight: 600;
  font-size: 0.9rem;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, gap 0.2s ease;
}
.rf-prize__select:hover {
  border-color: var(--rf-accent-soft);
  color: var(--rf-accent-text);
  background: var(--rf-accent-wash);
  gap: 11px;
}
.rf-prize--active .rf-prize__select {
  border-color: transparent;
  color: #422006;
  background-image: var(--rf-gold-grad);
  box-shadow: 0 6px 16px -8px rgba(245, 158, 11, 0.6);
}

/* ==========================================================================
   Section 3 — Participants
   ========================================================================== */
.rf-participants__grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.rf-participant {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 18px;
  border-radius: var(--rf-radius-sm);
  border: 1px solid var(--rf-border);
  background: var(--rf-surface);
  box-shadow: var(--rf-shadow-sm);
  overflow: hidden;
  transition: border-color 0.22s ease, box-shadow 0.22s ease, transform 0.22s ease;
}
.rf-participant:hover {
  border-color: var(--rf-accent-soft);
  box-shadow: var(--rf-shadow-md);
}
.rf-participant--skeleton {
  height: 76px;
  border-color: transparent;
  background: var(--rf-surface-soft);
  position: relative;
  overflow: hidden;
  box-shadow: none;
}
.rf-participant--skeleton::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(
    100deg,
    transparent 30%,
    color-mix(in srgb, var(--rf-amber) 10%, transparent) 50%,
    transparent 70%
  );
  animation: rf-shimmer 1.4s infinite;
}
@keyframes rf-shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}
.rf-participant__index {
  flex-shrink: 0;
  width: 22px;
  font-size: 0.74rem;
  font-weight: 800;
  color: var(--rf-text-faint);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}
.rf-participant__avatar {
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  color: var(--rf-av-fg);
  font-weight: 800;
  font-size: 0.92rem;
}
.rf-participant__avatar[data-variant='0'] { background-image: var(--rf-av-0); }
.rf-participant__avatar[data-variant='1'] { background-image: var(--rf-av-1); }
.rf-participant__avatar[data-variant='2'] { background-image: var(--rf-av-2); }
.rf-participant__avatar[data-variant='3'] { background-image: var(--rf-av-3); }
.rf-participant__body {
  flex: 1 1;
  min-width: 0;
}
.rf-participant__name {
  margin: 0;
  font-weight: 700;
  font-size: 0.98rem;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* States */
.rf-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 56px 20px;
  text-align: center;
  color: var(--rf-text-soft);
  border-radius: var(--rf-radius);
  border: 1px dashed var(--rf-border-strong);
  background: var(--rf-surface);
}

/* ==========================================================================
   Section 4 — Giveaway / raffle machine
   ========================================================================== */
.rf-machine-section {
  --rf-card-w: 142px;
  --rf-card-gap: 14px;
}
.rf-machine {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.rf-machine__skeleton {
  height: 340px;
  border-radius: var(--rf-radius);
  background: var(--rf-surface-soft);
  border: 1px solid var(--rf-border);
}
.rf-machine__stage {
  position: relative;
  padding: 26px;
  border-radius: var(--rf-radius);
  background:
    radial-gradient(120% 140% at 50% -20%, var(--rf-accent-wash), transparent 55%),
    linear-gradient(180deg, var(--rf-surface), var(--rf-bg-soft));
  border: 1px solid var(--rf-border-strong);
  box-shadow: var(--rf-shadow-md);
  overflow: hidden;
  transition: box-shadow 0.4s ease;
}
.rf-machine__stage::before {
  /* gold accent line along the top edge */
  content: '';
  position: absolute;
  top: 0;
  left: 12%;
  right: 12%;
  height: 1.5px;
  background: linear-gradient(90deg, transparent, var(--rf-amber), transparent);
  opacity: 0.7;
}
.rf-machine__stage--arming,
.rf-machine__stage--rolling,
.rf-machine__stage--slowing {
  box-shadow: var(--rf-shadow-md), var(--rf-shadow-gold);
}
.rf-machine__viewport {
  position: relative;
  height: 184px;
  overflow: hidden;
  border-radius: var(--rf-radius-sm);
}
.rf-machine__strip {
  display: flex;
  gap: var(--rf-card-gap);
  list-style: none;
  margin: 0;
  padding: 0;
  height: 100%;
  align-items: center;
  will-change: transform;
  transition: filter 0.4s ease;
}
.rf-machine__stage--rolling .rf-machine__strip {
  filter: blur(2.4px);
}
.rf-reel-card {
  flex: 0 0 var(--rf-card-w);
  width: var(--rf-card-w);
  height: 156px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 14px;
  border-radius: var(--rf-radius-sm);
  border: 1px solid var(--rf-border);
  background: var(--rf-surface);
  box-shadow: var(--rf-shadow-sm);
  text-align: center;
  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s ease,
    border-color 0.4s ease;
}
.rf-reel-card__avatar {
  width: 58px;
  height: 58px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  font-size: 1rem;
  font-weight: 800;
  color: var(--rf-av-fg);
}
.rf-reel-card__avatar[data-variant='0'] { background-image: var(--rf-av-0); }
.rf-reel-card__avatar[data-variant='1'] { background-image: var(--rf-av-1); }
.rf-reel-card__avatar[data-variant='2'] { background-image: var(--rf-av-2); }
.rf-reel-card__avatar[data-variant='3'] { background-image: var(--rf-av-3); }
.rf-reel-card__name {
  font-weight: 700;
  font-size: 0.88rem;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
/* Landed winner — celebratory pop + gold ring. */
.rf-reel-card--winner {
  border-color: transparent;
  background:
    linear-gradient(var(--rf-surface), var(--rf-surface)) padding-box,
    var(--rf-gold-grad) border-box;
  border: 2px solid transparent;
  box-shadow: 0 0 0 4px var(--rf-accent-soft), var(--rf-shadow-gold);
  animation: rf-winner-pop 0.7s cubic-bezier(0.18, 1.3, 0.4, 1) both;
}
@keyframes rf-winner-pop {
  0% { transform: scale(1); }
  40% { transform: scale(1.12) translateY(-4px); }
  100% { transform: scale(1.05) translateY(0); }
}

/* Center marker + light beam */
.rf-machine__beam {
  position: absolute;
  top: -10px;
  bottom: -10px;
  left: 50%;
  width: calc(var(--rf-card-w) + 28px);
  transform: translateX(-50%);
  border-radius: 20px;
  background: radial-gradient(60% 100% at 50% 50%, var(--rf-accent-wash), transparent 70%);
  z-index: 1;
  pointer-events: none;
  opacity: 0.8;
}
.rf-machine__marker {
  position: absolute;
  top: -6px;
  bottom: -6px;
  left: 50%;
  width: calc(var(--rf-card-w) + 18px);
  transform: translateX(-50%);
  border-radius: 18px;
  border: 2px solid var(--rf-amber);
  background: linear-gradient(180deg, rgba(251, 191, 36, 0.1), transparent 30%, transparent 70%, rgba(251, 191, 36, 0.1));
  box-shadow: 0 0 24px -4px var(--rf-accent-soft), inset 0 0 20px -8px var(--rf-amber);
  pointer-events: none;
  z-index: 3;
  transition: box-shadow 0.4s ease, border-color 0.4s ease;
}
.rf-machine__stage--arming .rf-machine__marker {
  animation: rf-marker-arm 0.5s ease-in-out;
}
@keyframes rf-marker-arm {
  0%, 100% { box-shadow: 0 0 24px -4px var(--rf-accent-soft), inset 0 0 20px -8px var(--rf-amber); }
  50% { box-shadow: 0 0 42px 2px var(--rf-accent-soft), inset 0 0 26px -6px var(--rf-amber); }
}
.rf-machine__stage--slowing .rf-machine__marker {
  animation: rf-marker-suspense 1.1s ease-in-out infinite;
}
@keyframes rf-marker-suspense {
  0%, 100% { box-shadow: 0 0 26px -4px var(--rf-accent-soft), inset 0 0 20px -8px var(--rf-amber); }
  50% { box-shadow: 0 0 50px 4px var(--rf-accent-soft), inset 0 0 30px -4px var(--rf-amber); border-color: var(--rf-honey); }
}
.rf-machine__marker--win {
  box-shadow: 0 0 60px 6px var(--rf-accent-soft), inset 0 0 30px -4px var(--rf-amber);
}
.rf-machine__pointer {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  filter: drop-shadow(0 0 6px var(--rf-accent-soft));
}
.rf-machine__pointer--top {
  top: -2px;
  border-top: 11px solid var(--rf-amber);
}
.rf-machine__pointer--bottom {
  bottom: -2px;
  border-bottom: 11px solid var(--rf-amber);
}

/* Edge fades */
.rf-machine__fade {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 92px;
  z-index: 2;
  pointer-events: none;
}
.rf-machine__fade--left {
  left: 0;
  background: linear-gradient(90deg, var(--rf-surface), transparent);
}
.rf-machine__fade--right {
  right: 0;
  background: linear-gradient(270deg, var(--rf-surface), transparent);
}
.rf-machine__empty {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  z-index: 4;
  margin: 0;
  padding: 0 20px;
  text-align: center;
  color: var(--rf-text-soft);
  font-weight: 600;
  background: color-mix(in srgb, var(--rf-surface) 72%, transparent);
}

/* Controls */
.rf-machine__controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  text-align: center;
}
.rf-machine__prizes {
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  gap: 10px;
  width: 100%;
  max-width: 680px;
}
/* Filmstrip layout: every card shares flex-grow/shrink equally, so growing the
   active card's flex-basis makes it genuinely take more of the row (siblings
   compress to make room) instead of just scaling in place over them. Height is
   fixed and identical for every card/state — only width and the photo/icon
   crossfade inside \`__visual\` change, so the row never resizes and nothing
   below it jumps when the selection changes. */
.rf-prize-pick {
  position: relative;
  display: inline-flex;
  flex: 1 1 100px;
  min-width: 0;
  height: 235px;
  padding: 0;
  border-radius: 18px;
  border: 1px solid var(--rf-border);
  background: var(--rf-surface-soft);
  overflow: hidden;
  font-family: inherit;
  cursor: pointer;
  transition: flex-basis 0.5s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.25s ease,
    box-shadow 0.3s ease;
}
/* Purely visual (no width/height change), so hovering never reflows the
   label text — only the persistent --active state resizes the card. */
.rf-prize-pick:hover:not(:disabled) {
  border-color: var(--rf-accent-soft);
  box-shadow: var(--rf-shadow-sm);
}
.rf-prize-pick:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}
/* Full-bleed photo (no card padding) — inactive cards dim/desaturate it and
   the active one snaps back to full colour, so switching reads as one
   settling back while the other comes forward, not a layout jump. */
.rf-prize-pick__photo {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: saturate(0.7) brightness(0.8);
  transform: scale(1.03);
  transition: filter 0.45s ease, transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}
.rf-prize-pick__icon {
  position: absolute;
  inset: 0;
  margin: auto;
  width: 22px;
  height: 22px;
  color: var(--rf-text-soft);
  transition: width 0.4s cubic-bezier(0.16, 1, 0.3, 1), height 0.4s cubic-bezier(0.16, 1, 0.3, 1),
    color 0.2s ease;
}
/* Dark gradient so the white label stays legible over any photo. */
.rf-prize-pick__scrim {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, transparent 38%, rgba(12, 9, 4, 0.82) 100%);
  pointer-events: none;
}
/* Clamped to a fixed 2 lines regardless of card width, so the label never
   reflows to a different line count (and the row never jitters) as the
   active card grows/shrinks — only individual word-wrap points may shift
   smoothly during the width transition itself. */
.rf-prize-pick__label {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  margin: 0;
  padding: 8px 10px;
  font-weight: 700;
  font-size: 0.72rem;
  line-height: 1.22;
  color: #fff;
  text-align: center;
  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);
  transition: font-size 0.4s cubic-bezier(0.16, 1, 0.3, 1);
}
.rf-prize-pick--active {
  flex-basis: 340px;
  border-color: var(--rf-accent-soft);
  box-shadow: var(--rf-shadow-md);
}
.rf-prize-pick--active .rf-prize-pick__photo {
  filter: saturate(1) brightness(1);
  transform: scale(1);
}
.rf-prize-pick--active .rf-prize-pick__icon {
  width: 34px;
  height: 34px;
}
.rf-prize-pick--active .rf-prize-pick__label {
  padding: 12px 14px;
  font-size: 0.98rem;
}
.rf-machine__start {
  min-width: 240px;
}
.rf-machine__status {
  margin: 0;
  min-height: 1rem;
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--rf-text-faint);
}

/* ==========================================================================
   Section 5 — Transparency
   ========================================================================== */
.rf-transparency__card {
  position: relative;
  max-width: 700px;
  margin: 0 auto;
  padding: 52px 36px;
  text-align: center;
  border-radius: var(--rf-radius);
  border: 1px solid var(--rf-border);
  background:
    radial-gradient(120% 120% at 50% 0%, var(--rf-accent-wash), transparent 55%),
    var(--rf-surface);
  box-shadow: var(--rf-shadow-md);
  overflow: hidden;
}
.rf-transparency__icon {
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  border-radius: 20px;
  color: #422006;
  background-image: var(--rf-gold-grad);
  box-shadow: 0 10px 24px -10px rgba(245, 158, 11, 0.7), inset 0 1px 0 rgba(255, 255, 255, 0.5);
}
.rf-transparency__statement {
  margin: 16px 0 14px;
  font-size: clamp(1.35rem, 3vw, 1.9rem);
  font-weight: 800;
  letter-spacing: -0.025em;
  line-height: 1.25;
}
.rf-transparency__detail {
  margin: 0 auto;
  max-width: 540px;
  color: var(--rf-text-soft);
  line-height: 1.65;
}

/* ==========================================================================
   Footer
   ========================================================================== */
.rf-footer {
  position: relative;
  z-index: 1;
  margin-top: 40px;
  color: var(--rf-text-soft);
  /* Dark plaque, independent of the page theme (matches the main TeSalut site). */
  background: linear-gradient(180deg, #17150f 0%, #100e0c 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 32px 32px 0 0;
  overflow: hidden;
}
.rf-footer__inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: var(--rf-container);
  margin: 0 auto;
  padding: 56px var(--rf-gutter) 40px;
  display: grid;
  gap: 40px 48px;
  grid-template-columns: 1fr;
}
.rf-footer__col {
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: flex-start;
}
.rf-footer__brand {
  display: inline-flex;
  text-decoration: none;
}
.rf-footer__logo {
  height: 40px;
  width: auto;
}
.rf-footer__title {
  margin: 0 0 4px;
  font-size: 1.05rem;
  font-weight: 700;
  color: #fafaf9;
}
.rf-footer__addr,
.rf-footer__link {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  font-size: 0.94rem;
  color: rgba(214, 211, 205, 0.8);
  text-decoration: none;
  transition: color 0.2s ease;
}
.rf-footer__addr svg,
.rf-footer__link svg {
  flex: none;
  color: rgba(214, 211, 205, 0.55);
}
.rf-footer__link:hover {
  color: #fcd34d;
}
.rf-footer__link:hover svg {
  color: #fcd34d;
}
.rf-footer__privacy {
  font-size: 0.9rem;
  color: rgba(214, 211, 205, 0.7);
  text-decoration: none;
  transition: color 0.2s ease;
}
.rf-footer__privacy:hover {
  color: #fcd34d;
}
.rf-footer__socials {
  display: flex;
  align-items: center;
  gap: 14px;
}
.rf-footer__social {
  display: grid;
  place-items: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  color: rgba(214, 211, 205, 0.75);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease,
    transform 0.2s ease;
}
.rf-footer__social:hover {
  color: #fcd34d;
  background: rgba(253, 207, 8, 0.12);
  border-color: rgba(253, 207, 8, 0.45);
  transform: translateY(-2px);
}
.rf-footer__bottom {
  position: relative;
  z-index: 1;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding: 22px var(--rf-gutter);
  text-align: center;
  font-size: 0.84rem;
  color: rgba(214, 211, 205, 0.5);
}
.rf-footer__bottom p {
  margin: 0;
}
@media (min-width: 720px) {
  .rf-footer__inner {
    grid-template-columns: 1.4fr 1fr 1fr;
    align-items: start;
  }
}

/* ==========================================================================
   Winner modal
   ========================================================================== */
.rf-modal {
  position: fixed;
  inset: 0;
  z-index: 80;
  display: grid;
  place-items: center;
  padding: 20px;
  background:
    radial-gradient(120% 120% at 50% 30%, rgba(245, 158, 11, 0.16), transparent 60%),
    color-mix(in srgb, #1c1207 62%, transparent);
  backdrop-filter: blur(10px);
}
.rf-modal__card {
  position: relative;
  width: 100%;
  max-width: 440px;
  padding: 44px 30px 28px;
  text-align: center;
  border-radius: 28px;
  background: var(--rf-surface);
  border: 1px solid var(--rf-accent-soft);
  box-shadow: var(--rf-shadow-md), var(--rf-shadow-gold);
  overflow: hidden;
}
.rf-modal__glow {
  position: absolute;
  top: -120px;
  left: 50%;
  width: 380px;
  height: 380px;
  transform: translateX(-50%);
  background: radial-gradient(closest-side, var(--rf-glow-1), transparent 70%);
  pointer-events: none;
}
.rf-modal__rays {
  position: absolute;
  top: -40px;
  left: 50%;
  width: 460px;
  height: 460px;
  transform: translateX(-50%);
  background: conic-gradient(
    from 0deg,
    transparent 0deg,
    rgba(251, 191, 36, 0.14) 12deg,
    transparent 24deg,
    transparent 36deg,
    rgba(251, 191, 36, 0.14) 48deg,
    transparent 60deg
  );
  mask-image: radial-gradient(closest-side, #000 30%, transparent 72%);
  pointer-events: none;
  animation: rf-rays 18s linear infinite;
}
@keyframes rf-rays {
  to { transform: translateX(-50%) rotate(360deg); }
}
.rf-modal__close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 3;
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid var(--rf-border);
  background: var(--rf-surface);
  color: var(--rf-text-soft);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.rf-modal__close:hover {
  background: var(--rf-surface-soft);
  color: var(--rf-text);
}
.rf-modal__trophy {
  position: relative;
  z-index: 2;
  display: grid;
  place-items: center;
  width: 64px;
  height: 64px;
  margin: 4px auto 16px;
  border-radius: 20px;
  color: #422006;
  background-image: var(--rf-gold-grad-strong);
  box-shadow: 0 14px 30px -10px rgba(245, 158, 11, 0.75), inset 0 1px 0 rgba(255, 255, 255, 0.6);
  animation: rf-trophy-bob 3s ease-in-out infinite;
}
@keyframes rf-trophy-bob {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  50% { transform: translateY(-5px) rotate(-2deg); }
}
.rf-modal__badge {
  position: relative;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 14px;
  border-radius: var(--rf-radius-pill);
  background: var(--rf-accent-wash);
  border: 1px solid var(--rf-accent-soft);
  color: var(--rf-accent-text);
  font-weight: 700;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.14em;
}
.rf-modal__avatar-stage {
  position: relative;
  z-index: 2;
  width: 96px;
  height: 96px;
  margin: 22px auto 18px;
}
.rf-modal__avatar-halo {
  position: absolute;
  inset: -10px;
  border-radius: 50%;
  background: conic-gradient(var(--rf-honey), var(--rf-amber), var(--rf-amber-deep), var(--rf-honey));
  filter: blur(6px);
  opacity: 0.7;
  animation: rf-rays 6s linear infinite;
}
.rf-modal__avatar {
  position: absolute;
  inset: 0;
  border-radius: 26px;
  display: grid;
  place-items: center;
  font-size: 1.9rem;
  font-weight: 800;
  color: var(--rf-av-fg);
  border: 3px solid var(--rf-surface);
  box-shadow: 0 0 0 1px var(--rf-accent-soft);
}
.rf-modal__avatar[data-variant='0'] { background-image: var(--rf-av-0); }
.rf-modal__avatar[data-variant='1'] { background-image: var(--rf-av-1); }
.rf-modal__avatar[data-variant='2'] { background-image: var(--rf-av-2); }
.rf-modal__avatar[data-variant='3'] { background-image: var(--rf-av-3); }
.rf-modal__congrats {
  position: relative;
  z-index: 2;
  margin: 0;
  color: var(--rf-text-faint);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 0.78rem;
}
.rf-modal__name {
  position: relative;
  z-index: 2;
  margin: 8px 0 10px;
  font-size: 1.8rem;
  font-weight: 800;
  letter-spacing: -0.025em;
}
.rf-modal__wins {
  position: relative;
  z-index: 2;
  margin: 0 0 26px;
  color: var(--rf-text-soft);
  font-size: 1rem;
}
.rf-modal__wins strong {
  color: var(--rf-accent-text);
  font-weight: 700;
}
/* Optional generated prize image inside the winner reveal. */
.rf-modal__prize {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 260px;
  margin: 0 auto 24px;
  aspect-ratio: 16 / 10;
  border-radius: var(--rf-radius-sm);
  overflow: hidden;
  border: 1px solid var(--rf-accent-soft);
  box-shadow: var(--rf-shadow-sm);
}
.rf-modal__prize-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
/* Celebration image (e.g. the golden gift box): a rendered object on a light
   backdrop. Instead of a hard card, let it float — soft radial mask fades the
   edges into the modal, a warm glow sits behind it, and in dark mode a \`screen\`
   blend drops the light background entirely. */
.rf-modal__prize--celebration {
  aspect-ratio: 1 / 1;
  max-width: 240px;
  margin: 0 auto 18px;
  border: none;
  box-shadow: none;
  border-radius: 0;
  overflow: visible;
  background: transparent;
}
.rf-modal__prize--celebration::before {
  content: '';
  position: absolute;
  inset: -6%;
  z-index: 0;
  border-radius: 50%;
  background: radial-gradient(
    closest-side,
    rgba(251, 191, 36, 0.4),
    rgba(251, 191, 36, 0.1) 55%,
    transparent 72%
  );
  filter: blur(6px);
}
.rf-modal__prize--celebration .rf-modal__prize-img {
  position: relative;
  z-index: 1;
  object-fit: contain;
  mask-image: radial-gradient(
    closest-side,
    #000 50%,
    rgba(0, 0, 0, 0.35) 66%,
    transparent 80%
  );
}
.rf-page[data-theme='dark'] .rf-modal__prize--celebration .rf-modal__prize-img {
  mix-blend-mode: screen;
}
/* Winner's role as a small centred chip (replaces the old boxed stat card). */
.rf-modal__stats {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  gap: 12px;
  margin: 0 0 26px;
}
.rf-modal__stat {
  flex: 1 1;
  max-width: 160px;
  padding: 15px;
  border-radius: var(--rf-radius-sm);
  background: var(--rf-surface-soft);
  border: 1px solid var(--rf-border);
}
.rf-modal__stat dt {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: var(--rf-text-faint);
  font-weight: 700;
  margin-bottom: 9px;
}
.rf-modal__stat dd {
  margin: 0;
  display: flex;
  justify-content: center;
}
.rf-modal__stat-num {
  font-size: 1.4rem;
  font-weight: 800;
  color: var(--rf-text);
  font-variant-numeric: tabular-nums;
}
.rf-modal__actions {
  position: relative;
  z-index: 2;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

/* ==========================================================================
   Confetti — one-shot celebration only
   ========================================================================== */
.rf-confetti {
  position: fixed;
  inset: 0;
  z-index: 70;
  pointer-events: none;
  overflow: hidden;
}
.rf-confetti__piece {
  position: absolute;
  top: 0;
  display: block;
}

/* ==========================================================================
   Responsive — tablet (>= 640px)
   ========================================================================== */
@media (min-width: 640px) {
  .rf-section {
    padding: 96px var(--rf-gutter);
  }
  .rf-participants__grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .rf-prizes__grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .rf-machine-section {
    --rf-card-w: 168px;
    --rf-card-gap: 16px;
  }
  .rf-machine__viewport {
    height: 200px;
  }
  .rf-modal__card {
    padding: 48px 36px 32px;
  }
}

/* ==========================================================================
   Responsive — desktop (>= 1024px)
   ========================================================================== */
@media (min-width: 1024px) {
  .rf-hero {
    padding-top: 88px;
  }
  .rf-hero__inner {
    grid-template-columns: 1.08fr 0.92fr;
    gap: 60px;
  }
  .rf-participants__grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .rf-machine-section {
    --rf-card-w: 186px;
    --rf-card-gap: 18px;
  }
  .rf-machine__viewport {
    height: 220px;
  }
  .rf-reel-card {
    height: 178px;
  }
}

/* ==========================================================================
   Responsive — large desktop (>= 1440px): widen the container so the layout
   fills big screens instead of stranding it in a narrow 1180px column, and add
   grid columns so rows stay dense rather than gappy.
   ========================================================================== */
@media (min-width: 1440px) {
  .rf-page {
    --rf-container: 1440px;
  }
  .rf-participants__grid {
    grid-template-columns: repeat(4, 1fr);
  }
  /* Keep the prize cards from stretching absurdly wide. */
  .rf-prizes__grid {
    max-width: 1160px;
    margin-inline: auto;
  }
}

@media (min-width: 1728px) {
  .rf-page {
    --rf-container: 1600px;
  }
  .rf-section {
    padding-block: 112px;
  }
  .rf-participants__grid {
    grid-template-columns: repeat(5, 1fr);
  }
}

@media (min-width: 2100px) {
  .rf-page {
    --rf-container: 1760px;
  }
}

/* ==========================================================================
   Date-range picker
   ========================================================================== */
.rf-daterange {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 9px;
  width: 100%;
  max-width: 360px;
  margin: 0 auto 40px;
}
.rf-daterange__label {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: var(--rf-text-faint);
}
.rf-daterange__label svg {
  color: var(--rf-accent-text);
}

/* Trigger — the whole field opens the popover, not just an icon. */
.rf-daterange__trigger {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 13px 16px;
  border-radius: var(--rf-radius-sm);
  border: 1px solid var(--rf-border-strong);
  background: var(--rf-surface);
  color: var(--rf-text);
  font-family: inherit;
  cursor: pointer;
  box-shadow: var(--rf-shadow-sm);
  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.rf-daterange__trigger:hover {
  border-color: var(--rf-accent-soft);
}
.rf-daterange__trigger.is-open {
  border-color: var(--rf-accent-soft);
  box-shadow: 0 0 0 3px var(--rf-accent-wash);
}
.rf-daterange__value {
  flex: 1 1;
  min-width: 0;
  text-align: left;
  font-size: 0.92rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rf-daterange__trigger:not(.has-value) .rf-daterange__value {
  color: var(--rf-text-faint);
  font-weight: 500;
}
.rf-daterange__chevron {
  flex: none;
  color: var(--rf-text-faint);
  transition: transform 0.22s ease, color 0.2s ease;
}
.rf-daterange__trigger.is-open .rf-daterange__chevron {
  transform: rotate(180deg);
  color: var(--rf-accent-text);
}
.rf-daterange--invalid .rf-daterange__trigger {
  border-color: #dc2626;
}

/* Popover calendar */
.rf-daterange__popover {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 30;
  width: 300px;
  padding: 14px;
  border-radius: var(--rf-radius);
  border: 1px solid var(--rf-border-strong);
  background: var(--rf-surface);
  box-shadow: var(--rf-shadow-md);
}
.rf-daterange__cal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}
.rf-daterange__nav {
  display: grid;
  place-items: center;
  width: 30px;
  height: 30px;
  border: 1px solid var(--rf-border);
  border-radius: var(--rf-radius-pill);
  background: var(--rf-surface-soft);
  color: var(--rf-text-soft);
  cursor: pointer;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}
.rf-daterange__nav:hover {
  color: var(--rf-accent-text);
  border-color: var(--rf-accent-soft);
  background: var(--rf-accent-wash);
}
.rf-daterange__nav--prev svg {
  transform: rotate(90deg);
}
.rf-daterange__nav--next svg {
  transform: rotate(-90deg);
}
.rf-daterange__month {
  font-size: 0.86rem;
  font-weight: 700;
  text-transform: capitalize;
  letter-spacing: -0.01em;
}
.rf-daterange__weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  margin-bottom: 4px;
}
.rf-daterange__weekdays span {
  display: block;
  text-align: center;
  font-size: 0.64rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--rf-text-faint);
  padding-bottom: 6px;
}
.rf-daterange__grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}
.rf-daterange__day {
  position: relative;
  aspect-ratio: 1;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--rf-text);
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}
.rf-daterange__day:hover {
  background: var(--rf-accent-wash);
}
.rf-daterange__day.is-dim {
  color: var(--rf-text-faint);
  opacity: 0.55;
}
.rf-daterange__day.is-today::after {
  content: '';
  position: absolute;
  bottom: 4px;
  left: 50%;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--rf-amber);
  transform: translateX(-50%);
}
.rf-daterange__day.is-in-range,
.rf-daterange__day.is-preview {
  background: var(--rf-accent-wash);
  border-radius: 0;
}
.rf-daterange__day.is-bound {
  background-image: var(--rf-gold-grad-strong);
  color: #422006;
  border-radius: 10px;
  font-weight: 800;
}
.rf-daterange__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--rf-border);
}
.rf-daterange__hint {
  font-size: 0.72rem;
  color: var(--rf-text-faint);
}
.rf-daterange__clear {
  padding: 5px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--rf-accent-text);
  font-family: inherit;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  cursor: pointer;
  transition: background 0.15s ease;
}
.rf-daterange__clear:hover {
  background: var(--rf-surface-soft);
}
.rf-daterange__error {
  margin: 0;
  font-size: 0.82rem;
  font-weight: 600;
  color: #dc2626;
  text-align: center;
}
/* ==========================================================================
   Reduced motion
   ========================================================================== */
@media (prefers-reduced-motion: reduce) {
  .rf-page *,
  .rf-page *::before,
  .rf-page *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
  .rf-hero__pulse,
  .rf-honeycomb__glow,
  .rf-modal__rays,
  .rf-modal__avatar-halo,
  .rf-modal__trophy,
  .rf-hex-particle {
    animation: none !important;
  }
  .rf-honeycomb__grid,
  .rf-honeycomb__particles,
  .rf-hero__content,
  .rf-hero__visual {
    transform: none !important;
  }
  .rf-bees {
    display: none !important;
  }
}

/* ==========================================================================
   Scroll-driven bees — fixed, dimmed layer on the FAR back plane (see
   ScrollBees). z-index 0 sits below .rf-main (z 1), so bees drift *behind* the
   content, showing through the transparent gaps around cards and text.
   ========================================================================== */
.rf-bees {
  position: fixed;
  inset: 0;
  z-index: 0; /* behind page content, above the page background */
  pointer-events: none;
  overflow: hidden;
  contain: strict; /* isolate paint/layout for cheap off-thread flights */
}

/* Layer 1 — travel from x0 → x1 (both per-bee, in vw) with a mid arc, running
   two animations in parallel: the curved flight and a graceful opacity fade so
   the bee eases in and dissolves out instead of popping. The endpoints decide
   the mode: full cross, vanish mid-screen, or an on-screen drift. */
.rf-bee {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  will-change: transform, opacity;
  animation-name: rf-bee-cross, rf-bee-fade;
  animation-timing-function: linear, ease-in-out;
  animation-iteration-count: 1, 1;
  animation-fill-mode: both, both;
  /* duration + delay are set inline and cycle across both animations */
}
@keyframes rf-bee-cross {
  0% {
    transform: translate3d(var(--rf-bee-x0, -18vw), 0, 0);
  }
  50% {
    transform: translate3d(var(--rf-bee-xm, 49vw), var(--rf-bee-arc, 0), 0);
  }
  100% {
    transform: translate3d(var(--rf-bee-x1, 116vw), var(--rf-bee-drift, 0), 0);
  }
}
/* Fade in, hold, fade out — peak opacity is the bee's depth-dimmed value. */
@keyframes rf-bee-fade {
  0% {
    opacity: 0;
  }
  16% {
    opacity: var(--rf-bee-opacity, 0.4);
  }
  76% {
    opacity: var(--rf-bee-opacity, 0.4);
  }
  100% {
    opacity: 0;
  }
}

/* Layer 2 — face direction of travel (SVG is drawn heading right). */
.rf-bee__flip {
  transform-origin: center;
}
.rf-bee--flip .rf-bee__flip {
  transform: scaleX(-1);
}

/* Layer 3 — organic vertical bob + resting scale/tilt. Depth-of-field blur and
   a soft shadow are applied here (blur strength comes from the bee's depth). */
.rf-bee__body {
  transform: scale(var(--rf-bee-scale, 1)) rotate(var(--rf-bee-tilt, 0deg));
  animation: rf-bee-bob var(--rf-bee-bob, 1.1s) ease-in-out infinite;
  filter: blur(var(--rf-bee-blur, 0)) drop-shadow(0 2px 3px rgba(28, 25, 23, 0.16));
}
@keyframes rf-bee-bob {
  0%,
  100% {
    transform: scale(var(--rf-bee-scale, 1)) translateY(0) rotate(var(--rf-bee-tilt, 0deg));
  }
  50% {
    transform: scale(var(--rf-bee-scale, 1))
      translateY(calc(var(--rf-bee-bob-amp, 8px) * -1))
      rotate(calc(var(--rf-bee-tilt, 0deg) + 4deg));
  }
}

/* Layer 4 — fast wing flutter. */
.rf-bee__wings {
  transform-box: fill-box;
  transform-origin: 60% 90%;
  animation: rf-bee-wings 0.11s ease-in-out infinite;
}
@keyframes rf-bee-wings {
  0%,
  100% {
    transform: scaleY(1) rotate(0deg);
  }
  50% {
    transform: scaleY(0.5) rotate(-7deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/raffle.css"],"names":[],"mappings":"AAAA;;;;;;;+EAO+E;;AAE/E,gFAAgF;AAChF;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,wBAAwB;EACxB,8EAA8E;EAC9E,qFAAqF;;EAErF,oCAAoC;EACpC,gBAAgB,EAAE,eAAe;EACjC,qBAAqB,EAAE,oBAAoB;EAC3C,qBAAqB;EACrB,0BAA0B;EAC1B,qCAAqC;EACrC,mCAAmC;EACnC,0CAA0C;;EAE1C,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;;EAExB,4BAA4B;EAC5B,yBAAyB,EAAE,8CAA8C;EACzE,0CAA0C;EAC1C,0CAA0C;EAC1C,mCAAmC;EACnC;;gFAE8E;EAC9E,8EAA8E;;EAE9E,uBAAuB;EACvB,uCAAuC;EACvC,oBAAoB;EACpB,qDAAqD;;EAErD,yFAAyF;EACzF,+FAA+F;EAC/F,4DAA4D;;EAE5D,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;;EAErC,iBAAiB;EACjB,mBAAmB;EACnB,sFAAsF;EACtF,kFAAkF;EAClF,wFAAwF;EACxF,qFAAqF;;EAErF,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,6EAA6E;EAC7E,sBAAsB;EACtB,mCAAmC;EACnC,qFAAqF;;EAErF,kBAAkB;EAClB,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,mCAAmC;EACnC,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,sCAAsC;EACtC,6CAA6C;;EAE7C,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;;EAExB,yBAAyB;EACzB,0CAA0C;EAC1C,0CAA0C;EAC1C,mCAAmC;EACnC,8EAA8E;;EAE9E,oBAAoB;;EAEpB,iFAAiF;EACjF,4FAA4F;EAC5F,2DAA2D;;EAE3D,uCAAuC;EACvC,oCAAoC;EACpC,oCAAoC;;EAEpC,mBAAmB;EACnB,qFAAqF;EACrF,uFAAuF;EACvF,wFAAwF;EACxF,oFAAoF;;EAEpF,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;;8EAE8E;AAC9E;;;;;;EAME,cAAc;EACd,oBAAoB;AACtB;;AAEA,yEAAyE;AACzE;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;oFACoF;AACpF;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;;AAEA;;+EAE+E;AAC/E;8DAC8D;AAC9D;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;;+CAG+C;AAC/C;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yDAAwT;EACxT,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,oCAAoC;EACpC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB;sFACoF;AACtF;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;yDAIyD;AACzD;;EAEE,uBAAuB;EACvB,4CAA4C;EAC5C,8BAA8B;AAChC;AACA;;EAEE,2BAA2B;EAC3B,uCAAuC;EACvC,mDAAmD;AACrD;AACA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,qCAAqC;EACrC,+BAA+B;AACjC;AACA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;;+EAE+E;AAC/E;;0CAE0C;AAC1C;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,6EAA6E;EAC7E,0EAA0E;EAC1E,yCAAyC;EACzC,kDAAkD;EAClD,4BAA4B;EAC5B,gDAAgD;EAChD,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,uCAAuC;EACvC,qCAAqC;EACrC,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,oCAAoC;AACtC;AACA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,cAAc;AAChB;AACA;EACE,qCAAqC;EACrC,qCAAqC;AACvC;AACA,8EAA8E;AAC9E;EACE;IACE,aAAa;EACf;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kCAAkC;EAClC,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,8FAA8F;AAChG;AACA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,oCAAoC;EACpC,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,oCAAoC;EACpC,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,6BAA6B;EAC7B,uCAAuC;EACvC,+BAA+B;EAC/B,wDAAwD;AAC1D;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,2BAA2B;AAC7B;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;EACpC,iCAAiC;EACjC,uCAAuC;EACvC,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,oCAAoC;AACtC;AACA;EAEE,0EAA0E;EAC1E,kFAAkF;EAClF,YAAY;AACd;AACA;EAEE,0EAA0E;EAC1E,gFAAgF;EAChF,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,4EAA4E;EAC5E,kDAAkD;AACpD;AACA;EACE,SAAS;EACT,aAAa;EACb,YAAY;EACZ,aAAa;EACb,4EAA4E;EAC5E,2DAA2D;AAC7D;AACA;EACE,WAAW,aAAa,EAAE,oCAAoC,EAAE;EAChE,MAAM,UAAU,EAAE,uCAAuC,EAAE;AAC7D;AACA;EACE,wEAAwE;EACxE,iCAAiC;AACnC;AACA;EACE,WAAW,YAAY,EAAE,mBAAmB,EAAE;EAC9C,MAAM,aAAa,EAAE,sBAAsB,EAAE;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gFAAgF;EAChF,oCAAoC;AACtC;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,sCAAsC;EACtC,4BAA4B;EAC5B,aAAa;EACb,qFAAqF;EACrF,sBAAsB;AACxB;AACA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,uEAAuE,EAAE;AACjF;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB;0EACwE;EACxE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;AACA;6EAC6E;AAC7E;EACE;;iFAE+E;AACjF;AACA;EACE;;mEAEiE;AACnE;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B,cAAc;EACd,2BAA2B;EAC3B,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,8EAA8E;EAC9E,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,yCAAyC;EACzC,yCAAyC;AAC3C;AACA;EACE,KAAK,2CAA2C,EAAE;EAClD,YAAY,2CAA2C,EAAE;AAC3D;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;6CAC6C;AAC7C;EACE,aAAa;EACb,uBAAuB;EACvB,kFAAkF;EAClF,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,oDAAoD;AACtD;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;EAClC,2BAA2B;EAC3B,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;EAC5B,wDAAwD;AAC1D;AACA;EACE,sDAAsD;AACxD;AACA;EACE,mCAAmC;EACnC,sDAAsD;AACxD;AACA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,cAAc;EACd;;;;;;;GAOC;EACD,8EAA8E;EAE9E,uBAAuB;EACvB,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;;EAEE,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,KAAK,kBAAkB,EAAE;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,iHAAiH;EACjH,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,oGAAoG;EACpG,4BAA4B;EAC5B,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mDAAmD;AACrD;AACA;oEACoE;AACpE;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,wCAAwC;EACxC,2CAA2C;EAC3C,8CAA8C;AAChD;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,qCAAqC;EACrC,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,oCAAoC;EACpC,4CAA4C;EAC5C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,oDAAoD;AACtD;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;EAClC,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,yEAAyE;AAC3E;AACA;;EAEE,4BAA4B;EAC5B,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,4EAA4E;EAC5E,UAAU;EACV,iBAAiB;EACjB,8BAA8B;AAChC;AACA;;EAEE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;EAC/B,0CAA0C;EAC1C,8EAA8E;EAE9E,uBAAuB;EACvB,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;2EAC2E;AAC3E;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,kCAAkC;EAClC,qDAAqD;EACrD,2BAA2B;EAC3B,wDAAwD;AAC1D;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,wDAAwD;EACxD,qCAAqC;AACvC;AACA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;AACA;;EAEE,sBAAsB;AACxB;AACA,uFAAuF;AACvF;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iFAAiF;EACjF,oBAAoB;AACtB;AACA;EACE,6EAA6E;AAC/E;AACA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,+BAA+B;EAC/B,8EAA8E;EAE9E,uBAAuB;EACvB,UAAU;EACV,8BAA8B;EAC9B,oBAAoB;AACtB;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,SAAO;AACT;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,oCAAoC;EACpC,yCAAyC;EACzC,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,wFAAwF;AAC1F;AACA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,iCAAiC;EACjC,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qCAAqC;EACrC,mDAAmD;AACrD;;AAEA;;+EAE+E;AAC/E;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;EAC/B,gBAAgB;EAChB,gFAAgF;AAClF;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,mCAAmC;AACrC;AACA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;AACA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,kCAAkC;EAClC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,4CAA4C,gCAAgC,EAAE;AAC9E,4CAA4C,gCAAgC,EAAE;AAC9E,4CAA4C,gCAAgC,EAAE;AAC9E,4CAA4C,gCAAgC,EAAE;AAC9E;EACE,SAAO;EACP,YAAY;AACd;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,0CAA0C;EAC1C,6BAA6B;AAC/B;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B;;iEAE+D;EAC/D,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,wCAAwC;EACxC,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,aAAa;EACb,6EAA6E;EAC7E,YAAY;AACd;AACA;;;EAGE,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;AAC9B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,+BAA+B;EAC/B,kBAAkB;EAClB;0BACwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA,0CAA0C,gCAAgC,EAAE;AAC5E,0CAA0C,gCAAgC,EAAE;AAC5E,0CAA0C,gCAAgC,EAAE;AAC5E,0CAA0C,gCAAgC,EAAE;AAC5E;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;AACA,iDAAiD;AACjD;EACE,yBAAyB;EACzB;;kCAEgC;EAChC,6BAA6B;EAC7B,kEAAkE;EAClE,kEAAkE;AACpE;AACA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,uCAAuC,EAAE;EAC/C,OAAO,oCAAoC,EAAE;AAC/C;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,wFAAwF;EACxF,UAAU;EACV,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,iCAAiC;EACjC,uHAAuH;EACvH,oFAAoF;EACpF,oBAAoB;EACpB,UAAU;EACV,wDAAwD;AAC1D;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,WAAW,oFAAoF,EAAE;EACjG,MAAM,mFAAmF,EAAE;AAC7F;AACA;EACE,uDAAuD;AACzD;AACA;EACE,WAAW,oFAAoF,EAAE;EACjG,MAAM,mFAAmF,EAAE,6BAA6B,EAAE;AAC5H;AACA;EACE,mFAAmF;AACrF;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kDAAkD;AACpD;AACA;EACE,SAAS;EACT,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,kEAAkE;AACpE;AACA;EACE,QAAQ;EACR,mEAAmE;AACrE;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,kEAAkE;AACpE;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;AACA;;;;;+CAK+C;AAC/C;EACE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,kCAAkC;EAClC,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf;wBACsB;AACxB;AACA;sEACsE;AACtE;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,aAAa;AACf;AACA;;oEAEoE;AACpE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,sBAAsB;EACtB,2EAA2E;AAC7E;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B;mBACiB;AACnB;AACA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,QAAQ;EACR,+EAA+E;EAC/E,oBAAoB;AACtB;AACA;;;iDAGiD;AACjD;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,wDAAwD;AAC1D;AACA;EACE,iBAAiB;EACjB,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,kCAAkC;EAClC;;qBAEmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,6FAA6F;AAC/F;AACA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,gFAAgF;EAChF,6DAA6D;EAC7D,+CAA+C;EAC/C,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;;EAEE,UAAU;EACV,gCAAgC;AAClC;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,qBAAqB;EACrB,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,2CAA2C;EAC3C;uBACqB;AACvB;AACA;EACE,cAAc;EACd,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,+CAA+C;EAC/C,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;AACA;EACE,SAAS;AACX;AACA;EACE;IACE,oCAAoC;IACpC,kBAAkB;EACpB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb;;gDAE8C;EAC9C,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,uCAAuC;EACvC,sDAAsD;EACtD,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,4EAA4E;EAC5E,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B;;;;;;;;GAQC;EAED,oEAAoE;EACpE,oBAAoB;EACpB,sCAAsC;AACxC;AACA;EACE,KAAK,0CAA0C,EAAE;AACnD;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,0BAA0B;EAC1B,eAAe;EACf,iDAAiD;AACnD;AACA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,4CAA4C;EAC5C,8FAA8F;EAC9F,gDAAgD;AAClD;AACA;EACE,WAAW,qCAAqC,EAAE;EAClD,MAAM,yCAAyC,EAAE;AACnD;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,iCAAiC;EACjC,uCAAuC;EACvC,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mGAAmG;EACnG,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mCAAmC;EACnC,2CAA2C;AAC7C;AACA,sCAAsC,gCAAgC,EAAE;AACxE,sCAAsC,gCAAgC,EAAE;AACxE,sCAAsC,gCAAgC,EAAE;AACxE,sCAAsC,gCAAgC,EAAE;AACxE;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA,6DAA6D;AAC7D;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;EAClC,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;;;+CAG+C;AAC/C;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB;;;;;GAKC;EACD,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;EAOnB;;;;;GAKC;AACH;AACA;EACE,sBAAsB;AACxB;AACA,8EAA8E;AAC9E;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;;AAEA;;+EAE+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,cAAc;AAChB;;AAEA;;+EAE+E;AAC/E;EACE;IACE,8BAA8B;EAChC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;;+EAE+E;AAC/E;EACE;IACE,iBAAiB;EACnB;EACA;IACE,oCAAoC;IACpC,SAAS;EACX;EACA;IACE,qCAAqC;EACvC;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;;;;+EAI+E;AAC/E;EACE;IACE,sBAAsB;EACxB;EACA;IACE,qCAAqC;EACvC;EACA,wDAAwD;EACxD;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;;+EAE+E;AAC/E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,yCAAyC;EACzC,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,8EAA8E;AAChF;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mCAAmC;EACnC,2CAA2C;AAC7C;AACA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,2BAA2B;EAC3B,iDAAiD;AACnD;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,yCAAyC;EACzC,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oCAAoC;EACpC,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;EACf,yEAAyE;AAC3E;AACA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,mDAAmD;AACrD;AACA;EACE,iCAAiC;AACnC;AACA;EACE,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;;EAEE,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;;+EAE+E;AAC/E;EACE;;;IAGE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;IACvC,gCAAgC;EAClC;EACA;;;;;;IAME,0BAA0B;EAC5B;EACA;;;;IAIE,0BAA0B;EAC5B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;;;;+EAI+E;AAC/E;EACE,eAAe;EACf,QAAQ;EACR,UAAU,EAAE,mDAAmD;EAC/D,oBAAoB;EACpB,gBAAgB;EAChB,eAAe,EAAE,sDAAsD;AACzE;;AAEA;;;oEAGoE;AACpE;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,+BAA+B;EAC/B,yCAAyC;EACzC,8CAA8C;EAC9C,+BAA+B;EAC/B,+BAA+B;EAC/B,qEAAqE;AACvE;AACA;EACE;IACE,qDAAqD;EACvD;EACA;IACE,uEAAuE;EACzE;EACA;IACE,0EAA0E;EAC5E;AACF;AACA,4EAA4E;AAC5E;EACE;IACE,UAAU;EACZ;EACA;IACE,mCAAmC;EACrC;EACA;IACE,mCAAmC;EACrC;EACA;IACE,UAAU;EACZ;AACF;;AAEA,qEAAqE;AACrE;EACE,wBAAwB;AAC1B;AACA;EACE,qBAAqB;AACvB;;AAEA;+EAC+E;AAC/E;EACE,yEAAyE;EACzE,kEAAkE;EAClE,iFAAiF;AACnF;AACA;EACE;;IAEE,uFAAuF;EACzF;EACA;IACE;;mDAE+C;EACjD;AACF;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kDAAkD;AACpD;AACA;EACE;;IAEE,iCAAiC;EACnC;EACA;IACE,oCAAoC;EACtC;AACF","sourcesContent":["/* ==========================================================================\n   TeSalut Giveaway (raffle) campaign page.\n   Premium SaaS aesthetic (Linear / Stripe / Raycast) warmed by a honey/gold\n   brand: refined neutral surfaces, near-black/near-white text, and gold used\n   deliberately for action, light and celebration — never as a flood of yellow.\n   Light + dark themes via [data-theme]. Scoped under .rf-page.\n   Mobile-first; scales at 640px (tablet) and 1024px (desktop).\n   ========================================================================== */\n\n/* Registered custom properties enable animating gradient angles & spotlights. */\n@property --rf-angle {\n  syntax: '<angle>';\n  inherits: false;\n  initial-value: 0deg;\n}\n\n.rf-page {\n  /* ---- Brand constants ---- */\n  --rf-honey: #fbbf24;\n  --rf-amber: #f59e0b;\n  --rf-amber-deep: #d97706;\n  --rf-gold-grad: linear-gradient(135deg, #fde68a 0%, #fbbf24 42%, #f59e0b 100%);\n  --rf-gold-grad-strong: linear-gradient(135deg, #fcd34d 0%, #f59e0b 55%, #d97706 100%);\n\n  /* ---- Light theme (default) ---- */\n  --rf-bg: #fffdfa; /* warm white */\n  --rf-bg-soft: #faf7f1; /* cream off-white */\n  --rf-surface: #ffffff;\n  --rf-surface-soft: #f6f3ed;\n  --rf-glass: rgba(255, 255, 255, 0.72);\n  --rf-border: rgba(28, 25, 23, 0.09);\n  --rf-border-strong: rgba(28, 25, 23, 0.16);\n\n  --rf-text: #1c1917;\n  --rf-text-soft: #57534e;\n  --rf-text-faint: #a8a29e;\n\n  --rf-accent: var(--rf-honey);\n  --rf-accent-text: #b45309; /* honey accent text w/ AA contrast on light */\n  --rf-accent-wash: rgba(251, 191, 36, 0.12);\n  --rf-accent-soft: rgba(245, 158, 11, 0.38);\n  --rf-spot: rgba(251, 191, 36, 0.28);\n  /* Gradient-clipped text: kept dark enough at every stop to hold AA/large-text\n     contrast on the page background (unlike --rf-gold-grad*, which is tuned to\n     sit *behind* dark button text, not to be read as foreground text itself). */\n  --rf-text-grad: linear-gradient(135deg, #b45309 0%, #92400e 55%, #7c2d12 100%);\n\n  /* Gold action button */\n  --rf-btn-bg: var(--rf-gold-grad-strong);\n  --rf-btn-fg: #422006;\n  --rf-btn-glow: 0 8px 18px -6px rgba(217, 119, 6, 0.5);\n\n  --rf-shadow-sm: 0 1px 2px rgba(28, 25, 23, 0.04), 0 6px 16px -10px rgba(28, 25, 23, 0.14);\n  --rf-shadow-md: 0 6px 14px -6px rgba(28, 25, 23, 0.1), 0 24px 48px -22px rgba(28, 25, 23, 0.22);\n  --rf-shadow-gold: 0 18px 50px -20px rgba(245, 158, 11, 0.45);\n\n  --rf-hex-line: rgba(180, 83, 9, 0.07);\n  --rf-glow-1: rgba(251, 191, 36, 0.22);\n  --rf-glow-2: rgba(245, 158, 11, 0.14);\n\n  /* avatar tints */\n  --rf-av-fg: #78350f;\n  --rf-av-0: linear-gradient(135deg, rgba(253, 230, 138, 0.7), rgba(251, 191, 36, 0.35));\n  --rf-av-1: linear-gradient(135deg, rgba(28, 25, 23, 0.08), rgba(28, 25, 23, 0.03));\n  --rf-av-2: linear-gradient(135deg, rgba(168, 162, 158, 0.22), rgba(168, 162, 158, 0.08));\n  --rf-av-3: linear-gradient(135deg, rgba(217, 119, 6, 0.28), rgba(245, 158, 11, 0.12));\n\n  --rf-radius: 20px;\n  --rf-radius-sm: 14px;\n  --rf-radius-pill: 999px;\n  /* Fluid content width — grows on larger displays (see responsive section). */\n  --rf-container: 1240px;\n  --rf-gutter: clamp(20px, 4vw, 56px);\n  --rf-font: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n\n  position: relative;\n  min-height: 100vh;\n  font-family: var(--rf-font);\n  color: var(--rf-text);\n  background: var(--rf-bg);\n  color-scheme: light;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n  font-feature-settings: 'cv11', 'ss01';\n  overflow-x: hidden;\n}\n\n.rf-page[data-theme='dark'] {\n  --rf-bg: #0b0a09;\n  --rf-bg-soft: #100e0c;\n  --rf-surface: #17150f;\n  --rf-surface-soft: #1f1c16;\n  --rf-glass: rgba(34, 30, 22, 0.55);\n  --rf-border: rgba(255, 240, 214, 0.09);\n  --rf-border-strong: rgba(255, 240, 214, 0.18);\n\n  --rf-text: #fafaf9;\n  --rf-text-soft: #b6b0a6;\n  --rf-text-faint: #79716a;\n\n  --rf-accent-text: #fcd34d;\n  --rf-accent-wash: rgba(251, 191, 36, 0.14);\n  --rf-accent-soft: rgba(251, 191, 36, 0.42);\n  --rf-spot: rgba(251, 191, 36, 0.22);\n  --rf-text-grad: linear-gradient(135deg, #fde68a 0%, #fcd34d 55%, #f5b83d 100%);\n\n  --rf-btn-fg: #2a1a02;\n\n  --rf-shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.45), 0 6px 16px -8px rgba(0, 0, 0, 0.6);\n  --rf-shadow-md: 0 10px 26px -10px rgba(0, 0, 0, 0.65), 0 28px 56px -24px rgba(0, 0, 0, 0.75);\n  --rf-shadow-gold: 0 20px 60px -22px rgba(245, 158, 11, 0.5);\n\n  --rf-hex-line: rgba(251, 191, 36, 0.07);\n  --rf-glow-1: rgba(251, 191, 36, 0.2);\n  --rf-glow-2: rgba(217, 119, 6, 0.16);\n\n  --rf-av-fg: #fde68a;\n  --rf-av-0: linear-gradient(135deg, rgba(251, 191, 36, 0.32), rgba(217, 119, 6, 0.16));\n  --rf-av-1: linear-gradient(135deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.03));\n  --rf-av-2: linear-gradient(135deg, rgba(255, 255, 255, 0.07), rgba(255, 255, 255, 0.02));\n  --rf-av-3: linear-gradient(135deg, rgba(245, 158, 11, 0.3), rgba(217, 119, 6, 0.14));\n\n  color-scheme: dark;\n}\n\n.rf-page *,\n.rf-page *::before,\n.rf-page *::after {\n  box-sizing: border-box;\n}\n\n/* Neutralise the app-wide global heading rule (styles.css sets a navy colour\n   and heading font on every h1-h6) so raffle headings follow the theme.\n   Only colour/family are reset — per-class size & weight intentionally win. */\n.rf-page h1,\n.rf-page h2,\n.rf-page h3,\n.rf-page h4,\n.rf-page h5,\n.rf-page h6 {\n  color: inherit;\n  font-family: inherit;\n}\n\n/* Disable transitions during a theme swap so colours change instantly. */\n.rf-page--switching,\n.rf-page--switching * {\n  transition: none !important;\n}\n\n.rf-page :focus-visible {\n  outline: 2px solid var(--rf-amber);\n  outline-offset: 2px;\n  border-radius: 8px;\n}\n/* Pill controls must keep their full radius on focus so the outline hugs the\n   pill instead of falling back to the generic 8px (which clips the rounded ends). */\n.rf-page .rf-btn:focus-visible {\n  border-radius: var(--rf-radius-pill);\n}\n.rf-page .rf-prize-pick:focus-visible {\n  border-radius: 18px;\n}\n\n/* Skip link --------------------------------------------------------------- */\n.rf-skip {\n  position: absolute;\n  left: 16px;\n  top: -60px;\n  z-index: 60;\n  padding: 10px 16px;\n  border-radius: var(--rf-radius-pill);\n  background: var(--rf-text);\n  color: var(--rf-bg);\n  font-weight: 600;\n  text-decoration: none;\n  transition: top 0.2s ease;\n}\n.rf-skip:focus {\n  top: 16px;\n}\n\n/* ==========================================================================\n   Utilities — gradient text + film grain\n   ========================================================================== */\n/* Gold gradient clipped to text. Use for one emphasised phrase per view (hero\n   headline accent, winner name) — not for whole paragraphs. */\n.rf-grad-text {\n  background-image: var(--rf-text-grad);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n/* Faint animated-free noise texture for the always-dark surfaces (header,\n   footer, hero, winner modal), à la Linear/Stripe. Static (no motion), so it\n   needs no reduced-motion guard. Host element needs position + overflow:hidden\n   for the tile to clip to any border-radius. */\n.rf-grain {\n  position: relative;\n}\n.rf-grain::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\");\n  background-size: 160px 160px;\n  opacity: 0.05;\n  mix-blend-mode: overlay;\n  pointer-events: none;\n}\n\n/* ==========================================================================\n   Buttons\n   ========================================================================== */\n.rf-btn {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px 22px;\n  border: 1px solid transparent;\n  border-radius: var(--rf-radius-pill);\n  font-family: inherit;\n  font-size: 0.94rem;\n  font-weight: 600;\n  letter-spacing: -0.01em;\n  line-height: 1;\n  cursor: pointer;\n  text-decoration: none;\n  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.22s ease,\n    filter 0.22s ease, background 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;\n}\n.rf-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.rf-btn--lg {\n  padding: 15px 28px;\n  font-size: 1rem;\n}\n\n/* Primary = gold action with a warm glow. Kept deliberately simple (single\n   box-shadow, no clipped pseudo-element sheen) — overflow:hidden + a rounded\n   border-radius + an inner shadow/gradient combo triggered a corner-seam\n   rendering artifact in some browsers where a stray sliver of the sheen\n   showed up outside the pill near the top-left corner. */\n.rf-btn--primary,\n.rf-btn--gold {\n  color: var(--rf-btn-fg);\n  background-image: var(--rf-gold-grad-strong);\n  box-shadow: var(--rf-btn-glow);\n}\n.rf-btn--primary:hover:not(:disabled),\n.rf-btn--gold:hover:not(:disabled) {\n  transform: translateY(-2px);\n  filter: saturate(1.08) brightness(1.03);\n  box-shadow: 0 12px 26px -8px rgba(217, 119, 6, 0.6);\n}\n.rf-btn--ghost {\n  color: var(--rf-text);\n  background: var(--rf-surface);\n  border-color: var(--rf-border-strong);\n  box-shadow: var(--rf-shadow-sm);\n}\n.rf-btn--ghost:hover:not(:disabled) {\n  background: var(--rf-surface-soft);\n  border-color: var(--rf-accent-soft);\n  transform: translateY(-1px);\n}\n\n/* ==========================================================================\n   Header\n   ========================================================================== */\n/* Dark brand bar (matches the main TeSalut site header): near-black surface with\n   the gold wordmark, independent of the page's light/dark theme. Controls inside\n   are re-tinted for the dark bar below. */\n.rf-header {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  /* Dark→dark-grey gradient bar with rounded bottom edges, flush to the top. */\n  background: linear-gradient(180deg, #1c1a18 0%, #302d2a 62%, #3c3936 100%);\n  backdrop-filter: blur(16px) saturate(1.4);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 0 0 26px 26px;\n  box-shadow: 0 16px 36px -22px rgba(0, 0, 0, 0.9);\n  overflow: hidden;\n}\n.rf-header__inner {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: var(--rf-container);\n  margin: 0 auto;\n  padding: 14px clamp(20px, 4vw, 56px);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n.rf-header__actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.rf-brand {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  text-decoration: none;\n  color: #fafaf9;\n}\n.rf-brand__logo {\n  display: block;\n  height: clamp(30px, 3.2vw, 40px);\n  width: auto;\n}\n.rf-brand__tag {\n  padding: 4px 10px;\n  border-radius: var(--rf-radius-pill);\n  background: rgba(253, 207, 8, 0.14);\n  border: 1px solid rgba(253, 207, 8, 0.4);\n  font-size: 0.62rem;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #fcd34d;\n  font-weight: 700;\n}\n\n/* Re-tint the header controls for the always-dark bar. */\n.rf-header .rf-theme-toggle {\n  border-color: rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(250, 250, 249, 0.78);\n}\n.rf-header .rf-theme-toggle:hover {\n  color: #fcd34d;\n  border-color: rgba(253, 207, 8, 0.5);\n}\n.rf-header .rf-lang {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n.rf-header .rf-lang__btn {\n  color: rgba(250, 250, 249, 0.6);\n}\n.rf-header .rf-lang__btn[aria-pressed='true'] {\n  color: #fcd34d;\n}\n.rf-header .rf-lang__thumb {\n  background: rgba(255, 255, 255, 0.12);\n  border-color: rgba(253, 207, 8, 0.45);\n}\n/* On narrow phones the wordmark + controls fill the bar; drop the tag pill. */\n@media (max-width: 420px) {\n  .rf-brand__tag {\n    display: none;\n  }\n}\n\n/* Theme toggle */\n.rf-theme-toggle {\n  display: grid;\n  place-items: center;\n  width: 38px;\n  height: 38px;\n  border-radius: var(--rf-radius-pill);\n  border: 1px solid var(--rf-border);\n  background: var(--rf-surface);\n  color: var(--rf-text-soft);\n  cursor: pointer;\n  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease, transform 0.2s ease;\n}\n.rf-theme-toggle:hover {\n  color: var(--rf-accent-text);\n  border-color: var(--rf-accent-soft);\n  transform: translateY(-1px);\n}\n.rf-theme-toggle__icon {\n  display: grid;\n  place-items: center;\n}\n\n/* Language switcher */\n.rf-lang {\n  position: relative;\n  display: inline-flex;\n  padding: 4px;\n  border-radius: var(--rf-radius-pill);\n  background: var(--rf-surface-soft);\n  border: 1px solid var(--rf-border);\n}\n.rf-lang__btn {\n  position: relative;\n  z-index: 1;\n  min-width: 44px;\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  border-radius: var(--rf-radius-pill);\n  font-family: inherit;\n  font-weight: 600;\n  font-size: 0.8rem;\n  color: var(--rf-text-faint);\n  cursor: pointer;\n  transition: color 0.2s ease;\n}\n.rf-lang__btn[aria-pressed='true'] {\n  color: var(--rf-accent-text);\n}\n.rf-lang__thumb {\n  position: absolute;\n  top: 4px;\n  bottom: 4px;\n  width: 44px;\n  border-radius: var(--rf-radius-pill);\n  background: var(--rf-surface);\n  border: 1px solid var(--rf-accent-soft);\n  box-shadow: var(--rf-shadow-sm);\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n.rf-lang__thumb[data-active='ru'] {\n  transform: translateX(0);\n}\n.rf-lang__thumb[data-active='ro'] {\n  transform: translateX(44px);\n}\n\n/* ==========================================================================\n   Layout primitives\n   ========================================================================== */\n.rf-main {\n  position: relative;\n  z-index: 1;\n}\n.rf-section {\n  position: relative;\n  width: 100%;\n  max-width: var(--rf-container);\n  margin: 0 auto;\n  padding: 80px var(--rf-gutter);\n}\n.rf-section__head {\n  max-width: 680px;\n  margin: 0 auto 48px;\n  text-align: center;\n}\n.rf-section__title {\n  margin: 20px 0 14px;\n  font-size: clamp(1.8rem, 4vw, 2.7rem);\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.1;\n}\n.rf-section__subtitle {\n  margin: 0;\n  color: var(--rf-text-soft);\n  font-size: 1.05rem;\n  line-height: 1.6;\n}\n.rf-count-pill {\n  display: inline-block;\n  margin-left: 10px;\n  padding: 3px 11px;\n  border-radius: var(--rf-radius-pill);\n  background: var(--rf-accent-wash);\n  border: 1px solid var(--rf-accent-soft);\n  color: var(--rf-accent-text);\n  font-size: 0.8rem;\n  font-weight: 700;\n  vertical-align: middle;\n}\n\n/* ==========================================================================\n   Honeycomb backdrop (layered grid + glow + floating hexes + parallax)\n   ========================================================================== */\n.rf-honeycomb {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n.rf-honeycomb__grid {\n  position: absolute;\n  inset: -60px;\n  color: var(--rf-hex-line);\n  transition: transform 0.35s ease-out;\n}\n.rf-honeycomb__grid--back {\n  -webkit-mask-image: radial-gradient(120% 78% at 50% 8%, #000 24%, transparent 70%);\n  mask-image: radial-gradient(120% 78% at 50% 8%, #000 24%, transparent 70%);\n  transform: translate(calc(var(--rf-px, 0) * -16px), calc(var(--rf-py, 0) * -12px));\n  opacity: 0.7;\n}\n.rf-honeycomb__grid--front {\n  -webkit-mask-image: radial-gradient(95% 70% at 50% 14%, #000 16%, transparent 62%);\n  mask-image: radial-gradient(95% 70% at 50% 14%, #000 16%, transparent 62%);\n  transform: translate(calc(var(--rf-px, 0) * 22px), calc(var(--rf-py, 0) * 16px));\n  color: var(--rf-accent-wash);\n}\n.rf-honeycomb__glow {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(20px);\n  pointer-events: none;\n}\n.rf-honeycomb__glow--primary {\n  top: -220px;\n  left: 50%;\n  width: 760px;\n  height: 540px;\n  transform: translateX(-50%);\n  background: radial-gradient(closest-side, var(--rf-glow-1), transparent 72%);\n  animation: rf-glow-breathe 9s ease-in-out infinite;\n}\n.rf-honeycomb__glow--secondary {\n  top: 40px;\n  right: -160px;\n  width: 460px;\n  height: 460px;\n  background: radial-gradient(closest-side, var(--rf-glow-2), transparent 72%);\n  animation: rf-glow-breathe 11s ease-in-out infinite reverse;\n}\n@keyframes rf-glow-breathe {\n  0%, 100% { opacity: 0.75; transform: translateX(-50%) scale(1); }\n  50% { opacity: 1; transform: translateX(-50%) scale(1.06); }\n}\n.rf-honeycomb__glow--secondary {\n  /* secondary isn't centered, so override the translate in the keyframe */\n  animation-name: rf-glow-breathe-2;\n}\n@keyframes rf-glow-breathe-2 {\n  0%, 100% { opacity: 0.6; transform: scale(1); }\n  50% { opacity: 0.95; transform: scale(1.08); }\n}\n\n.rf-honeycomb__particles {\n  position: absolute;\n  inset: 0;\n  transform: translate(calc(var(--rf-px, 0) * 34px), calc(var(--rf-py, 0) * 26px));\n  transition: transform 0.35s ease-out;\n}\n.rf-hex-particle {\n  position: absolute;\n  width: var(--rf-hp-size);\n  height: calc(var(--rf-hp-size) * 1.14);\n  color: var(--rf-accent-soft);\n  opacity: 0.45;\n  animation: rf-float var(--rf-hp-dur, 10s) ease-in-out var(--rf-hp-delay, 0s) infinite;\n  will-change: transform;\n}\n@keyframes rf-float {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  50% { transform: translateY(-22px) rotate(calc(var(--rf-hp-spin, 1) * 12deg)); }\n}\n\n/* ==========================================================================\n   Section 1 — Hero\n   ========================================================================== */\n.rf-hero {\n  position: relative;\n  /* Full-bleed: the background wash + honeycomb span the whole viewport width\n     (no side \"bars\"); the content stays centred inside .rf-hero__inner. */\n  max-width: none;\n  width: 100%;\n  padding: 72px 0 100px;\n  overflow: hidden;\n}\n/* Theme-aware hero backdrop. The video is gone; the depth now comes from a soft\n   radial wash behind the honeycomb grid + the people collage on the right. */\n.rf-page[data-theme='dark'] .rf-hero {\n  background:\n    radial-gradient(120% 120% at 82% 8%, rgba(245, 158, 11, 0.16) 0%, transparent 46%),\n    radial-gradient(130% 100% at 50% -10%, rgba(24, 21, 16, 0.9) 0%, #0b0a09 60%);\n}\n.rf-page[data-theme='light'] .rf-hero {\n  background:\n    radial-gradient(120% 120% at 82% 8%, rgba(245, 158, 11, 0.1) 0%, transparent 48%),\n    linear-gradient(180deg, var(--rf-bg-soft) 0%, var(--rf-bg) 72%);\n}\n.rf-hero__inner {\n  position: relative;\n  z-index: 1;\n  max-width: var(--rf-container);\n  margin: 0 auto;\n  padding: 0 var(--rf-gutter);\n  display: grid;\n  gap: 48px;\n  align-items: center;\n}\n.rf-hero__content {\n  transform: translate(calc(var(--rf-px, 0) * 6px), calc(var(--rf-py, 0) * 4px));\n  transition: transform 0.4s ease-out;\n}\n.rf-hero__pulse {\n  position: relative;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--rf-amber);\n  box-shadow: 0 0 0 0 var(--rf-accent-soft);\n  animation: rf-ping 2.2s ease-out infinite;\n}\n@keyframes rf-ping {\n  0% { box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.5); }\n  70%, 100% { box-shadow: 0 0 0 8px rgba(245, 158, 11, 0); }\n}\n.rf-hero__title {\n  margin: 24px 0 18px;\n  font-size: clamp(1.85rem, 7vw, 3.9rem);\n  font-weight: 800;\n  line-height: 1.05;\n  letter-spacing: -0.04em;\n  overflow-wrap: break-word;\n  hyphens: auto;\n}\n.rf-hero__subtitle {\n  margin: 0 0 32px;\n  max-width: 540px;\n  font-size: 1.12rem;\n  line-height: 1.62;\n  color: var(--rf-text-soft);\n}\n.rf-hero__actions {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 40px;\n}\n.rf-hero__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 34px;\n  margin: 0;\n}\n.rf-hero__stat {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.rf-hero__stat-value {\n  font-size: 1.7rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  min-height: 1.7rem;\n  display: flex;\n  align-items: center;\n  font-variant-numeric: tabular-nums;\n}\n.rf-hero__stat-label {\n  margin: 0;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--rf-text-faint);\n  font-weight: 700;\n}\n.rf-hero__stat--live .rf-hero__stat-value .rf-hero__pulse {\n  width: 12px;\n  height: 12px;\n}\n\n/* Right-side hero visual — the people-honeycomb collage. Drifts subtly with the\n   pointer parallax like the old cards did. */\n.rf-hero__visual {\n  display: flex;\n  justify-content: center;\n  transform: translate(calc(var(--rf-px, 0) * -14px), calc(var(--rf-py, 0) * -10px));\n  transition: transform 0.4s ease-out;\n}\n.rf-hero__honeycomb {\n  width: 100%;\n  max-width: 640px;\n  height: auto;\n  object-fit: contain;\n  filter: drop-shadow(0 30px 60px rgba(0, 0, 0, 0.35));\n}\n\n/* ==========================================================================\n   Section 2 — Prizes\n   ========================================================================== */\n.rf-prizes__grid {\n  display: grid;\n  gap: 22px;\n}\n.rf-prize {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 32px;\n  border-radius: var(--rf-radius);\n  border: 1px solid var(--rf-border);\n  background: var(--rf-glass);\n  backdrop-filter: blur(14px) saturate(1.3);\n  box-shadow: var(--rf-shadow-sm);\n  overflow: hidden;\n  transform-style: preserve-3d;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n.rf-prize:hover {\n  box-shadow: var(--rf-shadow-md), var(--rf-shadow-gold);\n}\n.rf-prize--active {\n  border-color: var(--rf-accent-soft);\n  box-shadow: var(--rf-shadow-md), var(--rf-shadow-gold);\n}\n/* Animated gradient border (rotates on hover / when active). */\n.rf-prize__border {\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  padding: 1.5px;\n  background: conic-gradient(\n    from var(--rf-angle),\n    transparent 0deg,\n    var(--rf-honey) 60deg,\n    var(--rf-amber) 110deg,\n    transparent 180deg,\n    transparent 360deg\n  );\n  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  opacity: 0;\n  transition: opacity 0.35s ease;\n  pointer-events: none;\n}\n.rf-prize:hover .rf-prize__border,\n.rf-prize--active .rf-prize__border {\n  opacity: 1;\n  animation: rf-spin-border 4s linear infinite;\n}\n@keyframes rf-spin-border {\n  to { --rf-angle: 360deg; }\n}\n.rf-prize__spotlight {\n  position: absolute;\n  inset: 0;\n  border-radius: inherit;\n  background: radial-gradient(240px circle at var(--rf-mx, 50%) var(--rf-my, 50%), var(--rf-spot), transparent 60%);\n  opacity: 0;\n  transition: opacity 0.35s ease;\n  pointer-events: none;\n}\n.rf-prize:hover .rf-prize__spotlight {\n  opacity: 1;\n}\n.rf-prize__sheen {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(115deg, transparent 35%, rgba(255, 255, 255, 0.14) 48%, transparent 62%);\n  transform: translateX(-130%);\n  transition: transform 0.85s ease;\n  pointer-events: none;\n}\n.rf-prize:hover .rf-prize__sheen {\n  transform: translateX(130%);\n}\n.rf-prize__chip {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  border-radius: var(--rf-radius-pill);\n  background: var(--rf-gold-grad);\n  color: #422006;\n  font-size: 0.7rem;\n  font-weight: 700;\n  box-shadow: 0 4px 12px -4px rgba(245, 158, 11, 0.6);\n}\n/* Price + \"grand prize\" ribbon sit on the photo/art tile itself (not the card),\n   so they read as a product tag rather than floating card chrome. */\n.rf-prize__price-badge {\n  position: absolute;\n  left: 12px;\n  bottom: 12px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: baseline;\n  gap: 4px;\n  padding: 7px 13px;\n  border-radius: var(--rf-radius-pill);\n  background: rgba(20, 16, 10, 0.72);\n  backdrop-filter: blur(8px) saturate(1.4);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  box-shadow: 0 8px 20px -8px rgba(0, 0, 0, 0.5);\n}\n.rf-prize__price-num {\n  font-size: 1.05rem;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n  font-variant-numeric: tabular-nums;\n  background-image: var(--rf-gold-grad);\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent;\n}\n.rf-prize__price-cur {\n  font-size: 0.66rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: rgba(255, 255, 255, 0.75);\n}\n.rf-prize__ribbon {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  z-index: 2;\n  padding: 6px 12px;\n  border-radius: var(--rf-radius-pill);\n  background-image: var(--rf-gold-grad-strong);\n  color: #2a1a02;\n  font-size: 0.66rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  box-shadow: 0 6px 16px -6px rgba(245, 158, 11, 0.65);\n}\n.rf-prize__art {\n  position: relative;\n  width: 116px;\n  height: 116px;\n  margin-bottom: 24px;\n  display: grid;\n  place-items: center;\n  border-radius: 24px;\n  background: var(--rf-surface-soft);\n  border: 1px solid var(--rf-border);\n  color: var(--rf-text-soft);\n  transform: translateZ(28px);\n  transition: color 0.3s ease, background 0.3s ease, border-color 0.3s ease;\n}\n.rf-prize:hover .rf-prize__art,\n.rf-prize--active .rf-prize__art {\n  color: var(--rf-accent-text);\n  border-color: var(--rf-accent-soft);\n  background: var(--rf-accent-wash);\n}\n.rf-prize__art-glow {\n  position: absolute;\n  inset: 12px;\n  border-radius: 50%;\n  background: radial-gradient(closest-side, var(--rf-glow-1), transparent 72%);\n  opacity: 0;\n  filter: blur(8px);\n  transition: opacity 0.35s ease;\n}\n.rf-prize:hover .rf-prize__art-glow,\n.rf-prize--active .rf-prize__art-glow {\n  opacity: 1;\n}\n.rf-prize__art-ring {\n  position: absolute;\n  inset: -1px;\n  border-radius: inherit;\n  border: 1.5px solid transparent;\n  background: var(--rf-gold-grad) border-box;\n  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  opacity: 0;\n  transition: opacity 0.35s ease;\n}\n.rf-prize--active .rf-prize__art-ring {\n  opacity: 1;\n}\n.rf-prize__illustration {\n  position: relative;\n  width: 78px;\n  height: 78px;\n}\n/* Photo mode: a generated (Nano Banana) image shown as a premium banner.\n   Falls back to .rf-prize__art when the file is missing (see PrizeCard). */\n.rf-prize__photo {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  margin-bottom: 24px;\n  border-radius: 20px;\n  overflow: hidden;\n  background: var(--rf-surface-soft);\n  border: 1px solid var(--rf-border);\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);\n  transform: translateZ(28px);\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n.rf-prize__photo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transform: scale(1.01);\n  transition: transform 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n  animation: rf-photo-in 0.7s ease both;\n}\n@keyframes rf-photo-in {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n.rf-prize:hover .rf-prize__photo-img,\n.rf-prize--active .rf-prize__photo-img {\n  transform: scale(1.06);\n}\n/* Warm gradient veil so any photo blends into the honey theme + keeps title legible. */\n.rf-prize__photo::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, transparent 55%, rgba(28, 25, 23, 0.14) 100%);\n  pointer-events: none;\n}\n.rf-page[data-theme='dark'] .rf-prize__photo::after {\n  background: linear-gradient(180deg, transparent 45%, rgba(0, 0, 0, 0.4) 100%);\n}\n/* Gold ring that lights up on hover / active, matching the SVG art tile. */\n.rf-prize__photo-ring {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  border-radius: inherit;\n  padding: 1.5px;\n  background: var(--rf-gold-grad);\n  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  opacity: 0;\n  transition: opacity 0.35s ease;\n  pointer-events: none;\n}\n.rf-prize:hover .rf-prize__photo-ring,\n.rf-prize--active .rf-prize__photo-ring {\n  opacity: 1;\n}\n.rf-prize:hover .rf-prize__photo,\n.rf-prize--active .rf-prize__photo {\n  border-color: var(--rf-accent-soft);\n}\n.rf-prize__title {\n  margin: 0 0 12px;\n  font-size: 1.3rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n.rf-prize__desc {\n  margin: 0 0 20px;\n  color: var(--rf-text-soft);\n  line-height: 1.62;\n  flex: 1;\n}\n.rf-prize__select {\n  position: relative;\n  z-index: 2;\n  align-self: flex-start;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 11px 20px;\n  border-radius: var(--rf-radius-pill);\n  border: 1px solid var(--rf-border-strong);\n  background: var(--rf-surface);\n  color: var(--rf-text);\n  font-family: inherit;\n  font-weight: 600;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease, gap 0.2s ease;\n}\n.rf-prize__select:hover {\n  border-color: var(--rf-accent-soft);\n  color: var(--rf-accent-text);\n  background: var(--rf-accent-wash);\n  gap: 11px;\n}\n.rf-prize--active .rf-prize__select {\n  border-color: transparent;\n  color: #422006;\n  background-image: var(--rf-gold-grad);\n  box-shadow: 0 6px 16px -8px rgba(245, 158, 11, 0.6);\n}\n\n/* ==========================================================================\n   Section 3 — Participants\n   ========================================================================== */\n.rf-participants__grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 14px;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.rf-participant {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 18px;\n  border-radius: var(--rf-radius-sm);\n  border: 1px solid var(--rf-border);\n  background: var(--rf-surface);\n  box-shadow: var(--rf-shadow-sm);\n  overflow: hidden;\n  transition: border-color 0.22s ease, box-shadow 0.22s ease, transform 0.22s ease;\n}\n.rf-participant:hover {\n  border-color: var(--rf-accent-soft);\n  box-shadow: var(--rf-shadow-md);\n}\n.rf-participant--skeleton {\n  height: 76px;\n  border-color: transparent;\n  background: var(--rf-surface-soft);\n  position: relative;\n  overflow: hidden;\n  box-shadow: none;\n}\n.rf-participant--skeleton::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    100deg,\n    transparent 30%,\n    color-mix(in srgb, var(--rf-amber) 10%, transparent) 50%,\n    transparent 70%\n  );\n  animation: rf-shimmer 1.4s infinite;\n}\n@keyframes rf-shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n.rf-participant__index {\n  flex-shrink: 0;\n  width: 22px;\n  font-size: 0.74rem;\n  font-weight: 800;\n  color: var(--rf-text-faint);\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n}\n.rf-participant__avatar {\n  flex-shrink: 0;\n  width: 46px;\n  height: 46px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  color: var(--rf-av-fg);\n  font-weight: 800;\n  font-size: 0.92rem;\n}\n.rf-participant__avatar[data-variant='0'] { background-image: var(--rf-av-0); }\n.rf-participant__avatar[data-variant='1'] { background-image: var(--rf-av-1); }\n.rf-participant__avatar[data-variant='2'] { background-image: var(--rf-av-2); }\n.rf-participant__avatar[data-variant='3'] { background-image: var(--rf-av-3); }\n.rf-participant__body {\n  flex: 1;\n  min-width: 0;\n}\n.rf-participant__name {\n  margin: 0;\n  font-weight: 700;\n  font-size: 0.98rem;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* States */\n.rf-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding: 56px 20px;\n  text-align: center;\n  color: var(--rf-text-soft);\n  border-radius: var(--rf-radius);\n  border: 1px dashed var(--rf-border-strong);\n  background: var(--rf-surface);\n}\n\n/* ==========================================================================\n   Section 4 — Giveaway / raffle machine\n   ========================================================================== */\n.rf-machine-section {\n  --rf-card-w: 142px;\n  --rf-card-gap: 14px;\n}\n.rf-machine {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n.rf-machine__skeleton {\n  height: 340px;\n  border-radius: var(--rf-radius);\n  background: var(--rf-surface-soft);\n  border: 1px solid var(--rf-border);\n}\n.rf-machine__stage {\n  position: relative;\n  padding: 26px;\n  border-radius: var(--rf-radius);\n  background:\n    radial-gradient(120% 140% at 50% -20%, var(--rf-accent-wash), transparent 55%),\n    linear-gradient(180deg, var(--rf-surface), var(--rf-bg-soft));\n  border: 1px solid var(--rf-border-strong);\n  box-shadow: var(--rf-shadow-md);\n  overflow: hidden;\n  transition: box-shadow 0.4s ease;\n}\n.rf-machine__stage::before {\n  /* gold accent line along the top edge */\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 12%;\n  right: 12%;\n  height: 1.5px;\n  background: linear-gradient(90deg, transparent, var(--rf-amber), transparent);\n  opacity: 0.7;\n}\n.rf-machine__stage--arming,\n.rf-machine__stage--rolling,\n.rf-machine__stage--slowing {\n  box-shadow: var(--rf-shadow-md), var(--rf-shadow-gold);\n}\n.rf-machine__viewport {\n  position: relative;\n  height: 184px;\n  overflow: hidden;\n  border-radius: var(--rf-radius-sm);\n}\n.rf-machine__strip {\n  display: flex;\n  gap: var(--rf-card-gap);\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  align-items: center;\n  will-change: transform;\n  transition: filter 0.4s ease;\n}\n.rf-machine__stage--rolling .rf-machine__strip {\n  filter: blur(2.4px);\n}\n.rf-reel-card {\n  flex: 0 0 var(--rf-card-w);\n  width: var(--rf-card-w);\n  height: 156px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 14px;\n  border-radius: var(--rf-radius-sm);\n  border: 1px solid var(--rf-border);\n  background: var(--rf-surface);\n  box-shadow: var(--rf-shadow-sm);\n  text-align: center;\n  transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1), box-shadow 0.4s ease,\n    border-color 0.4s ease;\n}\n.rf-reel-card__avatar {\n  width: 58px;\n  height: 58px;\n  border-radius: 16px;\n  display: grid;\n  place-items: center;\n  font-size: 1rem;\n  font-weight: 800;\n  color: var(--rf-av-fg);\n}\n.rf-reel-card__avatar[data-variant='0'] { background-image: var(--rf-av-0); }\n.rf-reel-card__avatar[data-variant='1'] { background-image: var(--rf-av-1); }\n.rf-reel-card__avatar[data-variant='2'] { background-image: var(--rf-av-2); }\n.rf-reel-card__avatar[data-variant='3'] { background-image: var(--rf-av-3); }\n.rf-reel-card__name {\n  font-weight: 700;\n  font-size: 0.88rem;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n/* Landed winner — celebratory pop + gold ring. */\n.rf-reel-card--winner {\n  border-color: transparent;\n  background:\n    linear-gradient(var(--rf-surface), var(--rf-surface)) padding-box,\n    var(--rf-gold-grad) border-box;\n  border: 2px solid transparent;\n  box-shadow: 0 0 0 4px var(--rf-accent-soft), var(--rf-shadow-gold);\n  animation: rf-winner-pop 0.7s cubic-bezier(0.18, 1.3, 0.4, 1) both;\n}\n@keyframes rf-winner-pop {\n  0% { transform: scale(1); }\n  40% { transform: scale(1.12) translateY(-4px); }\n  100% { transform: scale(1.05) translateY(0); }\n}\n\n/* Center marker + light beam */\n.rf-machine__beam {\n  position: absolute;\n  top: -10px;\n  bottom: -10px;\n  left: 50%;\n  width: calc(var(--rf-card-w) + 28px);\n  transform: translateX(-50%);\n  border-radius: 20px;\n  background: radial-gradient(60% 100% at 50% 50%, var(--rf-accent-wash), transparent 70%);\n  z-index: 1;\n  pointer-events: none;\n  opacity: 0.8;\n}\n.rf-machine__marker {\n  position: absolute;\n  top: -6px;\n  bottom: -6px;\n  left: 50%;\n  width: calc(var(--rf-card-w) + 18px);\n  transform: translateX(-50%);\n  border-radius: 18px;\n  border: 2px solid var(--rf-amber);\n  background: linear-gradient(180deg, rgba(251, 191, 36, 0.1), transparent 30%, transparent 70%, rgba(251, 191, 36, 0.1));\n  box-shadow: 0 0 24px -4px var(--rf-accent-soft), inset 0 0 20px -8px var(--rf-amber);\n  pointer-events: none;\n  z-index: 3;\n  transition: box-shadow 0.4s ease, border-color 0.4s ease;\n}\n.rf-machine__stage--arming .rf-machine__marker {\n  animation: rf-marker-arm 0.5s ease-in-out;\n}\n@keyframes rf-marker-arm {\n  0%, 100% { box-shadow: 0 0 24px -4px var(--rf-accent-soft), inset 0 0 20px -8px var(--rf-amber); }\n  50% { box-shadow: 0 0 42px 2px var(--rf-accent-soft), inset 0 0 26px -6px var(--rf-amber); }\n}\n.rf-machine__stage--slowing .rf-machine__marker {\n  animation: rf-marker-suspense 1.1s ease-in-out infinite;\n}\n@keyframes rf-marker-suspense {\n  0%, 100% { box-shadow: 0 0 26px -4px var(--rf-accent-soft), inset 0 0 20px -8px var(--rf-amber); }\n  50% { box-shadow: 0 0 50px 4px var(--rf-accent-soft), inset 0 0 30px -4px var(--rf-amber); border-color: var(--rf-honey); }\n}\n.rf-machine__marker--win {\n  box-shadow: 0 0 60px 6px var(--rf-accent-soft), inset 0 0 30px -4px var(--rf-amber);\n}\n.rf-machine__pointer {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 0;\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  filter: drop-shadow(0 0 6px var(--rf-accent-soft));\n}\n.rf-machine__pointer--top {\n  top: -2px;\n  border-top: 11px solid var(--rf-amber);\n}\n.rf-machine__pointer--bottom {\n  bottom: -2px;\n  border-bottom: 11px solid var(--rf-amber);\n}\n\n/* Edge fades */\n.rf-machine__fade {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 92px;\n  z-index: 2;\n  pointer-events: none;\n}\n.rf-machine__fade--left {\n  left: 0;\n  background: linear-gradient(90deg, var(--rf-surface), transparent);\n}\n.rf-machine__fade--right {\n  right: 0;\n  background: linear-gradient(270deg, var(--rf-surface), transparent);\n}\n.rf-machine__empty {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  z-index: 4;\n  margin: 0;\n  padding: 0 20px;\n  text-align: center;\n  color: var(--rf-text-soft);\n  font-weight: 600;\n  background: color-mix(in srgb, var(--rf-surface) 72%, transparent);\n}\n\n/* Controls */\n.rf-machine__controls {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  text-align: center;\n}\n.rf-machine__prizes {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: stretch;\n  gap: 10px;\n  width: 100%;\n  max-width: 680px;\n}\n/* Filmstrip layout: every card shares flex-grow/shrink equally, so growing the\n   active card's flex-basis makes it genuinely take more of the row (siblings\n   compress to make room) instead of just scaling in place over them. Height is\n   fixed and identical for every card/state — only width and the photo/icon\n   crossfade inside `__visual` change, so the row never resizes and nothing\n   below it jumps when the selection changes. */\n.rf-prize-pick {\n  position: relative;\n  display: inline-flex;\n  flex: 1 1 100px;\n  min-width: 0;\n  height: 235px;\n  padding: 0;\n  border-radius: 18px;\n  border: 1px solid var(--rf-border);\n  background: var(--rf-surface-soft);\n  overflow: hidden;\n  font-family: inherit;\n  cursor: pointer;\n  transition: flex-basis 0.5s cubic-bezier(0.16, 1, 0.3, 1), border-color 0.25s ease,\n    box-shadow 0.3s ease;\n}\n/* Purely visual (no width/height change), so hovering never reflows the\n   label text — only the persistent --active state resizes the card. */\n.rf-prize-pick:hover:not(:disabled) {\n  border-color: var(--rf-accent-soft);\n  box-shadow: var(--rf-shadow-sm);\n}\n.rf-prize-pick:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n/* Full-bleed photo (no card padding) — inactive cards dim/desaturate it and\n   the active one snaps back to full colour, so switching reads as one\n   settling back while the other comes forward, not a layout jump. */\n.rf-prize-pick__photo {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: saturate(0.7) brightness(0.8);\n  transform: scale(1.03);\n  transition: filter 0.45s ease, transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n}\n.rf-prize-pick__icon {\n  position: absolute;\n  inset: 0;\n  margin: auto;\n  width: 22px;\n  height: 22px;\n  color: var(--rf-text-soft);\n  transition: width 0.4s cubic-bezier(0.16, 1, 0.3, 1), height 0.4s cubic-bezier(0.16, 1, 0.3, 1),\n    color 0.2s ease;\n}\n/* Dark gradient so the white label stays legible over any photo. */\n.rf-prize-pick__scrim {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, transparent 38%, rgba(12, 9, 4, 0.82) 100%);\n  pointer-events: none;\n}\n/* Clamped to a fixed 2 lines regardless of card width, so the label never\n   reflows to a different line count (and the row never jitters) as the\n   active card grows/shrinks — only individual word-wrap points may shift\n   smoothly during the width transition itself. */\n.rf-prize-pick__label {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n  margin: 0;\n  padding: 8px 10px;\n  font-weight: 700;\n  font-size: 0.72rem;\n  line-height: 1.22;\n  color: #fff;\n  text-align: center;\n  text-shadow: 0 1px 4px rgba(0, 0, 0, 0.5);\n  transition: font-size 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n}\n.rf-prize-pick--active {\n  flex-basis: 340px;\n  border-color: var(--rf-accent-soft);\n  box-shadow: var(--rf-shadow-md);\n}\n.rf-prize-pick--active .rf-prize-pick__photo {\n  filter: saturate(1) brightness(1);\n  transform: scale(1);\n}\n.rf-prize-pick--active .rf-prize-pick__icon {\n  width: 34px;\n  height: 34px;\n}\n.rf-prize-pick--active .rf-prize-pick__label {\n  padding: 12px 14px;\n  font-size: 0.98rem;\n}\n.rf-machine__start {\n  min-width: 240px;\n}\n.rf-machine__status {\n  margin: 0;\n  min-height: 1rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--rf-text-faint);\n}\n\n/* ==========================================================================\n   Section 5 — Transparency\n   ========================================================================== */\n.rf-transparency__card {\n  position: relative;\n  max-width: 700px;\n  margin: 0 auto;\n  padding: 52px 36px;\n  text-align: center;\n  border-radius: var(--rf-radius);\n  border: 1px solid var(--rf-border);\n  background:\n    radial-gradient(120% 120% at 50% 0%, var(--rf-accent-wash), transparent 55%),\n    var(--rf-surface);\n  box-shadow: var(--rf-shadow-md);\n  overflow: hidden;\n}\n.rf-transparency__icon {\n  display: grid;\n  place-items: center;\n  width: 64px;\n  height: 64px;\n  margin: 0 auto 20px;\n  border-radius: 20px;\n  color: #422006;\n  background-image: var(--rf-gold-grad);\n  box-shadow: 0 10px 24px -10px rgba(245, 158, 11, 0.7), inset 0 1px 0 rgba(255, 255, 255, 0.5);\n}\n.rf-transparency__statement {\n  margin: 16px 0 14px;\n  font-size: clamp(1.35rem, 3vw, 1.9rem);\n  font-weight: 800;\n  letter-spacing: -0.025em;\n  line-height: 1.25;\n}\n.rf-transparency__detail {\n  margin: 0 auto;\n  max-width: 540px;\n  color: var(--rf-text-soft);\n  line-height: 1.65;\n}\n\n/* ==========================================================================\n   Footer\n   ========================================================================== */\n.rf-footer {\n  position: relative;\n  z-index: 1;\n  margin-top: 40px;\n  color: var(--rf-text-soft);\n  /* Dark plaque, independent of the page theme (matches the main TeSalut site). */\n  background: linear-gradient(180deg, #17150f 0%, #100e0c 100%);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 32px 32px 0 0;\n  overflow: hidden;\n}\n.rf-footer__inner {\n  position: relative;\n  z-index: 1;\n  width: 100%;\n  max-width: var(--rf-container);\n  margin: 0 auto;\n  padding: 56px var(--rf-gutter) 40px;\n  display: grid;\n  gap: 40px 48px;\n  grid-template-columns: 1fr;\n}\n.rf-footer__col {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  align-items: flex-start;\n}\n.rf-footer__brand {\n  display: inline-flex;\n  text-decoration: none;\n}\n.rf-footer__logo {\n  height: 40px;\n  width: auto;\n}\n.rf-footer__title {\n  margin: 0 0 4px;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #fafaf9;\n}\n.rf-footer__addr,\n.rf-footer__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0;\n  font-size: 0.94rem;\n  color: rgba(214, 211, 205, 0.8);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n.rf-footer__addr svg,\n.rf-footer__link svg {\n  flex: none;\n  color: rgba(214, 211, 205, 0.55);\n}\n.rf-footer__link:hover {\n  color: #fcd34d;\n}\n.rf-footer__link:hover svg {\n  color: #fcd34d;\n}\n.rf-footer__privacy {\n  font-size: 0.9rem;\n  color: rgba(214, 211, 205, 0.7);\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n.rf-footer__privacy:hover {\n  color: #fcd34d;\n}\n.rf-footer__socials {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n.rf-footer__social {\n  display: grid;\n  place-items: center;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  color: rgba(214, 211, 205, 0.75);\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease,\n    transform 0.2s ease;\n}\n.rf-footer__social:hover {\n  color: #fcd34d;\n  background: rgba(253, 207, 8, 0.12);\n  border-color: rgba(253, 207, 8, 0.45);\n  transform: translateY(-2px);\n}\n.rf-footer__bottom {\n  position: relative;\n  z-index: 1;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  padding: 22px var(--rf-gutter);\n  text-align: center;\n  font-size: 0.84rem;\n  color: rgba(214, 211, 205, 0.5);\n}\n.rf-footer__bottom p {\n  margin: 0;\n}\n@media (min-width: 720px) {\n  .rf-footer__inner {\n    grid-template-columns: 1.4fr 1fr 1fr;\n    align-items: start;\n  }\n}\n\n/* ==========================================================================\n   Winner modal\n   ========================================================================== */\n.rf-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  background:\n    radial-gradient(120% 120% at 50% 30%, rgba(245, 158, 11, 0.16), transparent 60%),\n    color-mix(in srgb, #1c1207 62%, transparent);\n  backdrop-filter: blur(10px);\n}\n.rf-modal__card {\n  position: relative;\n  width: 100%;\n  max-width: 440px;\n  padding: 44px 30px 28px;\n  text-align: center;\n  border-radius: 28px;\n  background: var(--rf-surface);\n  border: 1px solid var(--rf-accent-soft);\n  box-shadow: var(--rf-shadow-md), var(--rf-shadow-gold);\n  overflow: hidden;\n}\n.rf-modal__glow {\n  position: absolute;\n  top: -120px;\n  left: 50%;\n  width: 380px;\n  height: 380px;\n  transform: translateX(-50%);\n  background: radial-gradient(closest-side, var(--rf-glow-1), transparent 70%);\n  pointer-events: none;\n}\n.rf-modal__rays {\n  position: absolute;\n  top: -40px;\n  left: 50%;\n  width: 460px;\n  height: 460px;\n  transform: translateX(-50%);\n  background: conic-gradient(\n    from 0deg,\n    transparent 0deg,\n    rgba(251, 191, 36, 0.14) 12deg,\n    transparent 24deg,\n    transparent 36deg,\n    rgba(251, 191, 36, 0.14) 48deg,\n    transparent 60deg\n  );\n  -webkit-mask-image: radial-gradient(closest-side, #000 30%, transparent 72%);\n  mask-image: radial-gradient(closest-side, #000 30%, transparent 72%);\n  pointer-events: none;\n  animation: rf-rays 18s linear infinite;\n}\n@keyframes rf-rays {\n  to { transform: translateX(-50%) rotate(360deg); }\n}\n.rf-modal__close {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 3;\n  display: grid;\n  place-items: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid var(--rf-border);\n  background: var(--rf-surface);\n  color: var(--rf-text-soft);\n  cursor: pointer;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n.rf-modal__close:hover {\n  background: var(--rf-surface-soft);\n  color: var(--rf-text);\n}\n.rf-modal__trophy {\n  position: relative;\n  z-index: 2;\n  display: grid;\n  place-items: center;\n  width: 64px;\n  height: 64px;\n  margin: 4px auto 16px;\n  border-radius: 20px;\n  color: #422006;\n  background-image: var(--rf-gold-grad-strong);\n  box-shadow: 0 14px 30px -10px rgba(245, 158, 11, 0.75), inset 0 1px 0 rgba(255, 255, 255, 0.6);\n  animation: rf-trophy-bob 3s ease-in-out infinite;\n}\n@keyframes rf-trophy-bob {\n  0%, 100% { transform: translateY(0) rotate(0deg); }\n  50% { transform: translateY(-5px) rotate(-2deg); }\n}\n.rf-modal__badge {\n  position: relative;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 14px;\n  border-radius: var(--rf-radius-pill);\n  background: var(--rf-accent-wash);\n  border: 1px solid var(--rf-accent-soft);\n  color: var(--rf-accent-text);\n  font-weight: 700;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n}\n.rf-modal__avatar-stage {\n  position: relative;\n  z-index: 2;\n  width: 96px;\n  height: 96px;\n  margin: 22px auto 18px;\n}\n.rf-modal__avatar-halo {\n  position: absolute;\n  inset: -10px;\n  border-radius: 50%;\n  background: conic-gradient(var(--rf-honey), var(--rf-amber), var(--rf-amber-deep), var(--rf-honey));\n  filter: blur(6px);\n  opacity: 0.7;\n  animation: rf-rays 6s linear infinite;\n}\n.rf-modal__avatar {\n  position: absolute;\n  inset: 0;\n  border-radius: 26px;\n  display: grid;\n  place-items: center;\n  font-size: 1.9rem;\n  font-weight: 800;\n  color: var(--rf-av-fg);\n  border: 3px solid var(--rf-surface);\n  box-shadow: 0 0 0 1px var(--rf-accent-soft);\n}\n.rf-modal__avatar[data-variant='0'] { background-image: var(--rf-av-0); }\n.rf-modal__avatar[data-variant='1'] { background-image: var(--rf-av-1); }\n.rf-modal__avatar[data-variant='2'] { background-image: var(--rf-av-2); }\n.rf-modal__avatar[data-variant='3'] { background-image: var(--rf-av-3); }\n.rf-modal__congrats {\n  position: relative;\n  z-index: 2;\n  margin: 0;\n  color: var(--rf-text-faint);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-size: 0.78rem;\n}\n.rf-modal__name {\n  position: relative;\n  z-index: 2;\n  margin: 8px 0 10px;\n  font-size: 1.8rem;\n  font-weight: 800;\n  letter-spacing: -0.025em;\n}\n.rf-modal__wins {\n  position: relative;\n  z-index: 2;\n  margin: 0 0 26px;\n  color: var(--rf-text-soft);\n  font-size: 1rem;\n}\n.rf-modal__wins strong {\n  color: var(--rf-accent-text);\n  font-weight: 700;\n}\n/* Optional generated prize image inside the winner reveal. */\n.rf-modal__prize {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: 260px;\n  margin: 0 auto 24px;\n  aspect-ratio: 16 / 10;\n  border-radius: var(--rf-radius-sm);\n  overflow: hidden;\n  border: 1px solid var(--rf-accent-soft);\n  box-shadow: var(--rf-shadow-sm);\n}\n.rf-modal__prize-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n/* Celebration image (e.g. the golden gift box): a rendered object on a light\n   backdrop. Instead of a hard card, let it float — soft radial mask fades the\n   edges into the modal, a warm glow sits behind it, and in dark mode a `screen`\n   blend drops the light background entirely. */\n.rf-modal__prize--celebration {\n  aspect-ratio: 1 / 1;\n  max-width: 240px;\n  margin: 0 auto 18px;\n  border: none;\n  box-shadow: none;\n  border-radius: 0;\n  overflow: visible;\n  background: transparent;\n}\n.rf-modal__prize--celebration::before {\n  content: '';\n  position: absolute;\n  inset: -6%;\n  z-index: 0;\n  border-radius: 50%;\n  background: radial-gradient(\n    closest-side,\n    rgba(251, 191, 36, 0.4),\n    rgba(251, 191, 36, 0.1) 55%,\n    transparent 72%\n  );\n  filter: blur(6px);\n}\n.rf-modal__prize--celebration .rf-modal__prize-img {\n  position: relative;\n  z-index: 1;\n  object-fit: contain;\n  -webkit-mask-image: radial-gradient(\n    closest-side,\n    #000 50%,\n    rgba(0, 0, 0, 0.35) 66%,\n    transparent 80%\n  );\n  mask-image: radial-gradient(\n    closest-side,\n    #000 50%,\n    rgba(0, 0, 0, 0.35) 66%,\n    transparent 80%\n  );\n}\n.rf-page[data-theme='dark'] .rf-modal__prize--celebration .rf-modal__prize-img {\n  mix-blend-mode: screen;\n}\n/* Winner's role as a small centred chip (replaces the old boxed stat card). */\n.rf-modal__stats {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n  margin: 0 0 26px;\n}\n.rf-modal__stat {\n  flex: 1;\n  max-width: 160px;\n  padding: 15px;\n  border-radius: var(--rf-radius-sm);\n  background: var(--rf-surface-soft);\n  border: 1px solid var(--rf-border);\n}\n.rf-modal__stat dt {\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: var(--rf-text-faint);\n  font-weight: 700;\n  margin-bottom: 9px;\n}\n.rf-modal__stat dd {\n  margin: 0;\n  display: flex;\n  justify-content: center;\n}\n.rf-modal__stat-num {\n  font-size: 1.4rem;\n  font-weight: 800;\n  color: var(--rf-text);\n  font-variant-numeric: tabular-nums;\n}\n.rf-modal__actions {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n}\n\n/* ==========================================================================\n   Confetti — one-shot celebration only\n   ========================================================================== */\n.rf-confetti {\n  position: fixed;\n  inset: 0;\n  z-index: 70;\n  pointer-events: none;\n  overflow: hidden;\n}\n.rf-confetti__piece {\n  position: absolute;\n  top: 0;\n  display: block;\n}\n\n/* ==========================================================================\n   Responsive — tablet (>= 640px)\n   ========================================================================== */\n@media (min-width: 640px) {\n  .rf-section {\n    padding: 96px var(--rf-gutter);\n  }\n  .rf-participants__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .rf-prizes__grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  .rf-machine-section {\n    --rf-card-w: 168px;\n    --rf-card-gap: 16px;\n  }\n  .rf-machine__viewport {\n    height: 200px;\n  }\n  .rf-modal__card {\n    padding: 48px 36px 32px;\n  }\n}\n\n/* ==========================================================================\n   Responsive — desktop (>= 1024px)\n   ========================================================================== */\n@media (min-width: 1024px) {\n  .rf-hero {\n    padding-top: 88px;\n  }\n  .rf-hero__inner {\n    grid-template-columns: 1.08fr 0.92fr;\n    gap: 60px;\n  }\n  .rf-participants__grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .rf-machine-section {\n    --rf-card-w: 186px;\n    --rf-card-gap: 18px;\n  }\n  .rf-machine__viewport {\n    height: 220px;\n  }\n  .rf-reel-card {\n    height: 178px;\n  }\n}\n\n/* ==========================================================================\n   Responsive — large desktop (>= 1440px): widen the container so the layout\n   fills big screens instead of stranding it in a narrow 1180px column, and add\n   grid columns so rows stay dense rather than gappy.\n   ========================================================================== */\n@media (min-width: 1440px) {\n  .rf-page {\n    --rf-container: 1440px;\n  }\n  .rf-participants__grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n  /* Keep the prize cards from stretching absurdly wide. */\n  .rf-prizes__grid {\n    max-width: 1160px;\n    margin-inline: auto;\n  }\n}\n\n@media (min-width: 1728px) {\n  .rf-page {\n    --rf-container: 1600px;\n  }\n  .rf-section {\n    padding-block: 112px;\n  }\n  .rf-participants__grid {\n    grid-template-columns: repeat(5, 1fr);\n  }\n}\n\n@media (min-width: 2100px) {\n  .rf-page {\n    --rf-container: 1760px;\n  }\n}\n\n/* ==========================================================================\n   Date-range picker\n   ========================================================================== */\n.rf-daterange {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  width: 100%;\n  max-width: 360px;\n  margin: 0 auto 40px;\n}\n.rf-daterange__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: var(--rf-text-faint);\n}\n.rf-daterange__label svg {\n  color: var(--rf-accent-text);\n}\n\n/* Trigger — the whole field opens the popover, not just an icon. */\n.rf-daterange__trigger {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 13px 16px;\n  border-radius: var(--rf-radius-sm);\n  border: 1px solid var(--rf-border-strong);\n  background: var(--rf-surface);\n  color: var(--rf-text);\n  font-family: inherit;\n  cursor: pointer;\n  box-shadow: var(--rf-shadow-sm);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;\n}\n.rf-daterange__trigger:hover {\n  border-color: var(--rf-accent-soft);\n}\n.rf-daterange__trigger.is-open {\n  border-color: var(--rf-accent-soft);\n  box-shadow: 0 0 0 3px var(--rf-accent-wash);\n}\n.rf-daterange__value {\n  flex: 1;\n  min-width: 0;\n  text-align: left;\n  font-size: 0.92rem;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.rf-daterange__trigger:not(.has-value) .rf-daterange__value {\n  color: var(--rf-text-faint);\n  font-weight: 500;\n}\n.rf-daterange__chevron {\n  flex: none;\n  color: var(--rf-text-faint);\n  transition: transform 0.22s ease, color 0.2s ease;\n}\n.rf-daterange__trigger.is-open .rf-daterange__chevron {\n  transform: rotate(180deg);\n  color: var(--rf-accent-text);\n}\n.rf-daterange--invalid .rf-daterange__trigger {\n  border-color: #dc2626;\n}\n\n/* Popover calendar */\n.rf-daterange__popover {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 30;\n  width: 300px;\n  padding: 14px;\n  border-radius: var(--rf-radius);\n  border: 1px solid var(--rf-border-strong);\n  background: var(--rf-surface);\n  box-shadow: var(--rf-shadow-md);\n}\n.rf-daterange__cal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n.rf-daterange__nav {\n  display: grid;\n  place-items: center;\n  width: 30px;\n  height: 30px;\n  border: 1px solid var(--rf-border);\n  border-radius: var(--rf-radius-pill);\n  background: var(--rf-surface-soft);\n  color: var(--rf-text-soft);\n  cursor: pointer;\n  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n}\n.rf-daterange__nav:hover {\n  color: var(--rf-accent-text);\n  border-color: var(--rf-accent-soft);\n  background: var(--rf-accent-wash);\n}\n.rf-daterange__nav--prev svg {\n  transform: rotate(90deg);\n}\n.rf-daterange__nav--next svg {\n  transform: rotate(-90deg);\n}\n.rf-daterange__month {\n  font-size: 0.86rem;\n  font-weight: 700;\n  text-transform: capitalize;\n  letter-spacing: -0.01em;\n}\n.rf-daterange__weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  margin-bottom: 4px;\n}\n.rf-daterange__weekdays span {\n  display: block;\n  text-align: center;\n  font-size: 0.64rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--rf-text-faint);\n  padding-bottom: 6px;\n}\n.rf-daterange__grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n.rf-daterange__day {\n  position: relative;\n  aspect-ratio: 1;\n  display: grid;\n  place-items: center;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--rf-text);\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n.rf-daterange__day:hover {\n  background: var(--rf-accent-wash);\n}\n.rf-daterange__day.is-dim {\n  color: var(--rf-text-faint);\n  opacity: 0.55;\n}\n.rf-daterange__day.is-today::after {\n  content: '';\n  position: absolute;\n  bottom: 4px;\n  left: 50%;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--rf-amber);\n  transform: translateX(-50%);\n}\n.rf-daterange__day.is-in-range,\n.rf-daterange__day.is-preview {\n  background: var(--rf-accent-wash);\n  border-radius: 0;\n}\n.rf-daterange__day.is-bound {\n  background-image: var(--rf-gold-grad-strong);\n  color: #422006;\n  border-radius: 10px;\n  font-weight: 800;\n}\n.rf-daterange__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 10px;\n  padding-top: 10px;\n  border-top: 1px solid var(--rf-border);\n}\n.rf-daterange__hint {\n  font-size: 0.72rem;\n  color: var(--rf-text-faint);\n}\n.rf-daterange__clear {\n  padding: 5px 10px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--rf-accent-text);\n  font-family: inherit;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.rf-daterange__clear:hover {\n  background: var(--rf-surface-soft);\n}\n.rf-daterange__error {\n  margin: 0;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #dc2626;\n  text-align: center;\n}\n/* ==========================================================================\n   Reduced motion\n   ========================================================================== */\n@media (prefers-reduced-motion: reduce) {\n  .rf-page *,\n  .rf-page *::before,\n  .rf-page *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n    scroll-behavior: auto !important;\n  }\n  .rf-hero__pulse,\n  .rf-honeycomb__glow,\n  .rf-modal__rays,\n  .rf-modal__avatar-halo,\n  .rf-modal__trophy,\n  .rf-hex-particle {\n    animation: none !important;\n  }\n  .rf-honeycomb__grid,\n  .rf-honeycomb__particles,\n  .rf-hero__content,\n  .rf-hero__visual {\n    transform: none !important;\n  }\n  .rf-bees {\n    display: none !important;\n  }\n}\n\n/* ==========================================================================\n   Scroll-driven bees — fixed, dimmed layer on the FAR back plane (see\n   ScrollBees). z-index 0 sits below .rf-main (z 1), so bees drift *behind* the\n   content, showing through the transparent gaps around cards and text.\n   ========================================================================== */\n.rf-bees {\n  position: fixed;\n  inset: 0;\n  z-index: 0; /* behind page content, above the page background */\n  pointer-events: none;\n  overflow: hidden;\n  contain: strict; /* isolate paint/layout for cheap off-thread flights */\n}\n\n/* Layer 1 — travel from x0 → x1 (both per-bee, in vw) with a mid arc, running\n   two animations in parallel: the curved flight and a graceful opacity fade so\n   the bee eases in and dissolves out instead of popping. The endpoints decide\n   the mode: full cross, vanish mid-screen, or an on-screen drift. */\n.rf-bee {\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n  will-change: transform, opacity;\n  animation-name: rf-bee-cross, rf-bee-fade;\n  animation-timing-function: linear, ease-in-out;\n  animation-iteration-count: 1, 1;\n  animation-fill-mode: both, both;\n  /* duration + delay are set inline and cycle across both animations */\n}\n@keyframes rf-bee-cross {\n  0% {\n    transform: translate3d(var(--rf-bee-x0, -18vw), 0, 0);\n  }\n  50% {\n    transform: translate3d(var(--rf-bee-xm, 49vw), var(--rf-bee-arc, 0), 0);\n  }\n  100% {\n    transform: translate3d(var(--rf-bee-x1, 116vw), var(--rf-bee-drift, 0), 0);\n  }\n}\n/* Fade in, hold, fade out — peak opacity is the bee's depth-dimmed value. */\n@keyframes rf-bee-fade {\n  0% {\n    opacity: 0;\n  }\n  16% {\n    opacity: var(--rf-bee-opacity, 0.4);\n  }\n  76% {\n    opacity: var(--rf-bee-opacity, 0.4);\n  }\n  100% {\n    opacity: 0;\n  }\n}\n\n/* Layer 2 — face direction of travel (SVG is drawn heading right). */\n.rf-bee__flip {\n  transform-origin: center;\n}\n.rf-bee--flip .rf-bee__flip {\n  transform: scaleX(-1);\n}\n\n/* Layer 3 — organic vertical bob + resting scale/tilt. Depth-of-field blur and\n   a soft shadow are applied here (blur strength comes from the bee's depth). */\n.rf-bee__body {\n  transform: scale(var(--rf-bee-scale, 1)) rotate(var(--rf-bee-tilt, 0deg));\n  animation: rf-bee-bob var(--rf-bee-bob, 1.1s) ease-in-out infinite;\n  filter: blur(var(--rf-bee-blur, 0)) drop-shadow(0 2px 3px rgba(28, 25, 23, 0.16));\n}\n@keyframes rf-bee-bob {\n  0%,\n  100% {\n    transform: scale(var(--rf-bee-scale, 1)) translateY(0) rotate(var(--rf-bee-tilt, 0deg));\n  }\n  50% {\n    transform: scale(var(--rf-bee-scale, 1))\n      translateY(calc(var(--rf-bee-bob-amp, 8px) * -1))\n      rotate(calc(var(--rf-bee-tilt, 0deg) + 4deg));\n  }\n}\n\n/* Layer 4 — fast wing flutter. */\n.rf-bee__wings {\n  transform-box: fill-box;\n  transform-origin: 60% 90%;\n  animation: rf-bee-wings 0.11s ease-in-out infinite;\n}\n@keyframes rf-bee-wings {\n  0%,\n  100% {\n    transform: scaleY(1) rotate(0deg);\n  }\n  50% {\n    transform: scaleY(0.5) rotate(-7deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
